(function ()
{
  'use strict';

  angular
    .module('dbs.offer', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $urlRouterProvider)
  {
    // State
    $stateProvider
      .state('dbs.offer', {
        url: '/offer/:code',
        views: {
          'content@dbs': {
            templateUrl: 'app/dbs/offer/offer-detail/offer-detail.html',
            controller: 'OfferController as vm',
            resolve: {
              offer: function ($rootScope, $stateParams, $state, $timeout, $q, favoriteService)
              {
                var d = $q.defer();
                //todo mutualise this function
                var offer = $rootScope._data.offers.find(function (x)
                {
                  return x.code === $stateParams.code;
                });

                $timeout(function ()
                {
                  if (offer)
                  {
                    favoriteService.visited.add($stateParams.code);
                    d.resolve(offer);
                  }
                  else if ($stateParams.code.indexOf("http") === 0)
                  {
                    //external link
                    window.open($stateParams.code, "_blank")
                    // d.reject({redirect: "dbs.notFound"});
                  } else
                  {
                    d.reject({redirect: "dbs.notFound"});
                  }
                });
                return d.promise;
              }
            }
          }
        }
      });
  }
})();

(function ()
{
  'use strict';

  angular
    .module('dbs.offer')
    .controller('OfferController', OfferController);

  /** @ngInject */
  function OfferController($scope, $rootScope, i18nService, offer, favoriteService, recommendedService)
  {

    $rootScope.title = i18nService.getTrans(offer.name);

    var vm = angular.merge(this, {
      offer: offer,
      recommendedOffers: recommendedService.getAll().filter(function (x)
      {
        return x.code !== offer.code
      }),
      addToFavorite: addToFavorite,
      redeemOffer: redeemOffer,
      encodeURIComponent: encodeURIComponent,
      openTermsAndConditionsModal: openTermsAndConditionsModal
    });
    // Methods

    function addToFavorite()
    {
      favoriteService.add(offer.code)
    }

    function redeemOffer(offerCode, offerName)
    {
      var offerNameTranslated = i18nService.getTrans(offerName, 'en');
      window.open($rootScope._data.website.redeemFormPageUrl + "?lang=" + $rootScope.lang + "&offer_id=" +
        encodeURIComponent(offerCode) + "&offer_name=" + encodeURIComponent(offerNameTranslated), '_blank')
      favoriteService.redeemed.add(offerCode);
    }

    function openTermsAndConditionsModal()
    {
      $("#terms-and-conditions-modal").modal("show");
    }
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core',
      [
        'ngAnimate',
        'ngAria',
        'ngCookies',
        'ngMessages',
        'ngResource',
        'ngSanitize',
        'pascalprecht.translate',
        'ui.router',
        'LocalStorageModule'
      ]);
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .controller('MsWidgetController', MsWidgetController)
    .directive('msWidget', msWidgetDirective)
    .directive('msWidgetFront', msWidgetFrontDirective)
    .directive('msWidgetBack', msWidgetBackDirective);

  /** @ngInject */
  function MsWidgetController($scope, $element)
  {
    var vm = this;

    // Data
    vm.flipped = false;

    // Methods
    vm.flip = flip;

    //////////

    /**
     * Flip the widget
     */
    function flip()
    {
      if (!isFlippable())
      {
        return;
      }

      // Toggle flipped status
      vm.flipped = !vm.flipped;

      // Toggle the 'flipped' class
      $element.toggleClass('flipped', vm.flipped);
    }

    /**
     * Check if widget is flippable
     *
     * @returns {boolean}
     */
    function isFlippable()
    {
      return (angular.isDefined($scope.flippable) && $scope.flippable === true);
    }
  }

  /** @ngInject */
  function msWidgetDirective()
  {
    return {
      restrict: 'E',
      scope: {
        flippable: '=?'
      },
      controller: 'MsWidgetController',
      transclude: true,
      compile: function (tElement)
      {
        tElement.addClass('ms-widget');

        return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
        {
          // Custom transclusion
          transcludeFn(function (clone)
          {
            iElement.empty();
            iElement.append(clone);
          });

          //////////
        };
      }
    };
  }

  /** @ngInject */
  function msWidgetFrontDirective()
  {
    return {
      restrict: 'E',
      require: '^msWidget',
      transclude: true,
      compile: function (tElement)
      {
        tElement.addClass('ms-widget-front');

        return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
        {
          // Custom transclusion
          transcludeFn(function (clone)
          {
            iElement.empty();
            iElement.append(clone);
          });

          // Methods
          scope.flipWidget = MsWidgetCtrl.flip;
        };
      }
    };
  }

  /** @ngInject */
  function msWidgetBackDirective()
  {
    return {
      restrict: 'E',
      require: '^msWidget',
      transclude: true,
      compile: function (tElement)
      {
        tElement.addClass('ms-widget-back');

        return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
        {
          // Custom transclusion
          transcludeFn(function (clone)
          {
            iElement.empty();
            iElement.append(clone);
          });

          // Methods
          scope.flipWidget = MsWidgetCtrl.flip;
        };
      }
    };
  }

})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .controller('MsTimelineController', MsTimelineController)
    .directive('msTimeline', msTimelineDirective)
    .directive('msTimelineItem', msTimelineItemDirective);

  /** @ngInject */
  function MsTimelineController()
  {
    var vm = this;

    // Data
    vm.scrollEl = undefined;

    // Methods
    vm.setScrollEl = setScrollEl;
    vm.getScrollEl = getScrollEl;

    //////////

    /**
     * Set scroll element
     *
     * @param scrollEl
     */
    function setScrollEl(scrollEl)
    {
      vm.scrollEl = scrollEl;
    }

    /**
     * Get scroll element
     *
     * @returns {undefined|*}
     */
    function getScrollEl()
    {
      return vm.scrollEl;
    }
  }

  /** @ngInject */
  function msTimelineDirective()
  {
    return {
      scope: {
        msTimeline: '=?',
        loadMore: '&?msTimelineLoadMore'
      },
      controller: 'MsTimelineController',
      compile: function (tElement)
      {
        tElement.addClass('ms-timeline');

        return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
        {
          // Create an element for triggering the load more action and append it
          var loadMoreEl = angular.element(
            '<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
          iElement.append(loadMoreEl);

          // Default config
          var config = {
            scrollEl: '#content'
          };

          // Extend the configuration
          config = angular.extend(config, scope.msTimeline, {});

          // Grab the scrollable element and store it in the controller for general use
          var scrollEl = angular.element(config.scrollEl);
          MsTimelineCtrl.setScrollEl(scrollEl);

          // Threshold
          var threshold = 144;

          // Register onScroll event for the first time
          registerOnScroll();

          /**
           * onScroll Event
           */
          function onScroll()
          {
            if (scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top)
            {
              // Show the loader
              loadMoreEl.addClass('show');

              // Unregister scroll event to prevent triggering the function over and over again
              unregisterOnScroll();

              // Trigger load more event
              scope.loadMore().then(
                // Success
                function ()
                {
                  // Hide the loader
                  loadMoreEl.removeClass('show');

                  // Register the onScroll event again
                  registerOnScroll();
                },

                // Error
                function ()
                {
                  // Remove the loader completely
                  loadMoreEl.remove();
                }
              );
            }
          }

          /**
           * onScroll event registerer
           */
          function registerOnScroll()
          {
            scrollEl.on('scroll', onScroll);
          }

          /**
           * onScroll event unregisterer
           */
          function unregisterOnScroll()
          {
            scrollEl.off('scroll', onScroll);
          }

          // Cleanup
          scope.$on('$destroy', function ()
          {
            unregisterOnScroll();
          });
        };
      }
    };
  }

  /** @ngInject */
  function msTimelineItemDirective($timeout, $q)
  {
    return {
      scope: true,
      require: '^msTimeline',
      compile: function (tElement)
      {
        tElement.addClass('ms-timeline-item').addClass('hidden');

        return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
        {
          var threshold = 72,
            itemLoaded = false,
            itemInViewport = false,
            scrollEl = MsTimelineCtrl.getScrollEl();

          //////////

          init();

          /**
           * Initialize
           */
          function init()
          {
            // Check if the timeline item has ms-card
            if (iElement.find('ms-card'))
            {
              // If the ms-card template loaded...
              scope.$on('msCard::cardTemplateLoaded', function (event, args)
              {
                var cardEl = angular.element(args[0]);

                // Test the card to see if there is any image on it
                testForImage(cardEl).then(function ()
                {
                  $timeout(function ()
                  {
                    itemLoaded = true;
                  });
                });
              });
            }
            else
            {
              // Test the element to see if there is any image on it
              testForImage(iElement).then(function ()
              {
                $timeout(function ()
                {
                  itemLoaded = true;
                });
              });
            }

            // Check if the loaded element also in the viewport
            scrollEl.on('scroll', testForVisibility);

            // Test for visibility for the first time without waiting for the scroll event
            testForVisibility();
          }

          // Item ready watcher
          var itemReadyWatcher = scope.$watch(
            function ()
            {
              return itemLoaded && itemInViewport;
            },
            function (current, old)
            {
              if (angular.equals(current, old))
              {
                return;
              }

              if (current)
              {
                iElement.removeClass('hidden').addClass('animate');

                // Unbind itemReadyWatcher
                itemReadyWatcher();
              }
            }, true);

          /**
           * Test the given element for image
           *
           * @param element
           * @returns promise
           */
          function testForImage(element)
          {
            var deferred = $q.defer(),
              imgEl = element.find('img');

            if (imgEl.length > 0)
            {
              imgEl.on('load', function ()
              {
                deferred.resolve('Image is loaded');
              });
            }
            else
            {
              deferred.resolve('No images');
            }

            return deferred.promise;
          }

          /**
           * Test the element for visibility
           */
          function testForVisibility()
          {
            if (scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold)
            {
              $timeout(function ()
              {
                itemInViewport = true;
              });

              // Unbind the scroll event
              scrollEl.off('scroll', testForVisibility);
            }
          }
        };
      }
    };
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .controller('MsStepperController', MsStepperController)
    .directive('msHorizontalStepper', msHorizontalStepperDirective)
    .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
    .directive('msVerticalStepper', msVerticalStepperDirective)
    .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

  /** @ngInject */
  function MsStepperController($timeout)
  {
    var vm = this;

    // Data
    vm.mainForm = undefined;

    vm.orientation = 'horizontal';
    vm.steps = [];
    vm.currentStep = undefined;
    vm.currentStepNumber = 1;

    // Methods
    vm.setOrientation = setOrientation;
    vm.registerMainForm = registerMainForm;
    vm.registerStep = registerStep;
    vm.setupSteps = setupSteps;
    vm.resetForm = resetForm;

    vm.setCurrentStep = setCurrentStep;

    vm.gotoStep = gotoStep;
    vm.gotoPreviousStep = gotoPreviousStep;
    vm.gotoNextStep = gotoNextStep;
    vm.gotoFirstStep = gotoFirstStep;
    vm.gotoLastStep = gotoLastStep;

    vm.isFirstStep = isFirstStep;
    vm.isLastStep = isLastStep;

    vm.isStepCurrent = isStepCurrent;
    vm.isStepDisabled = isStepDisabled;
    vm.isStepOptional = isStepOptional;
    vm.isStepHidden = isStepHidden;
    vm.filterHiddenStep = filterHiddenStep;
    vm.isStepValid = isStepValid;
    vm.isStepNumberValid = isStepNumberValid;

    vm.isFormValid = isFormValid;

    //////////

    /**
     * Set the orientation of the stepper
     *
     * @param orientation
     */
    function setOrientation(orientation)
    {
      vm.orientation = orientation || 'horizontal';
    }

    /**
     * Register the main form
     *
     * @param form
     */
    function registerMainForm(form)
    {
      vm.mainForm = form;
    }

    /**
     * Register a step
     *
     * @param element
     * @param scope
     * @param form
     */
    function registerStep(element, scope, form)
    {
      var step = {
        element: element,
        scope: scope,
        form: form,
        stepNumber: scope.step || (vm.steps.length + 1),
        stepTitle: scope.stepTitle,
        stepTitleTranslate: scope.stepTitleTranslate
      };

      // Push the step into steps array
      vm.steps.push(step);

      // Sort steps by stepNumber
      vm.steps.sort(function (a, b)
      {
        return a.stepNumber - b.stepNumber;
      });

      return step;
    }

    /**
     * Setup steps for the first time
     */
    function setupSteps()
    {
      vm.setCurrentStep(vm.currentStepNumber);
    }

    /**
     * Reset steps and the main form
     */
    function resetForm()
    {
      // Timeout is required here because we need to
      // let form model to reset before setting the
      // statuses
      $timeout(function ()
      {
        // Reset all the steps
        for (var x = 0; x < vm.steps.length; x++)
        {
          vm.steps[x].form.$setPristine();
          vm.steps[x].form.$setUntouched();
        }

        // Reset the main form
        vm.mainForm.$setPristine();
        vm.mainForm.$setUntouched();

        // Go to first step
        gotoFirstStep();
      });
    }

    /**
     * Set current step
     *
     * @param stepNumber
     */
    function setCurrentStep(stepNumber)
    {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber))
      {
        return;
      }

      // Update the current step number
      vm.currentStepNumber = stepNumber;

      if (vm.orientation === 'horizontal')
      {
        // Hide all steps
        for (var i = 0; i < vm.steps.length; i++)
        {
          vm.steps[i].element.hide();
        }

        // Show the current step
        vm.steps[vm.currentStepNumber - 1].element.show();
      }
      else if (vm.orientation === 'vertical')
      {
        // Hide all step content
        for (var j = 0; j < vm.steps.length; j++)
        {
          vm.steps[j].element.find('.ms-stepper-step-content').hide();
        }

        // Show the current step content
        vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
      }
    }

    /**
     * Go to a step
     *
     * @param stepNumber
     */
    function gotoStep(stepNumber)
    {
      // If the step we are about to go
      // is hidden, bail...
      if (isStepHidden(stepNumber))
      {
        return;
      }

      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the previous step
     */
    function gotoPreviousStep()
    {
      var stepNumber = vm.currentStepNumber - 1;

      // Test the previous steps and make sure we
      // will land to the one that is not hidden
      for (var s = stepNumber; s >= 1; s--)
      {
        if (!isStepHidden(s))
        {
          stepNumber = s;
          break;
        }
      }

      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the next step
     */
    function gotoNextStep()
    {
      var stepNumber = vm.currentStepNumber + 1;

      // Test the following steps and make sure we
      // will land to the one that is not hidden
      for (var s = stepNumber; s <= vm.steps.length; s++)
      {
        if (!isStepHidden(s))
        {
          stepNumber = s;
          break;
        }
      }

      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the first step
     */
    function gotoFirstStep()
    {
      vm.setCurrentStep(1);
    }

    /**
     * Go to the last step
     */
    function gotoLastStep()
    {
      vm.setCurrentStep(vm.steps.length);
    }

    /**
     * Check if the current step is the first step
     *
     * @returns {boolean}
     */
    function isFirstStep()
    {
      return vm.currentStepNumber === 1;
    }

    /**
     * Check if the current step is the last step
     *
     * @returns {boolean}
     */
    function isLastStep()
    {
      return vm.currentStepNumber === vm.steps.length;
    }

    /**
     * Check if the given step is the current one
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepCurrent(stepNumber)
    {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber))
      {
        return null;
      }

      return vm.currentStepNumber === stepNumber;
    }

    /**
     * Check if the given step should be disabled
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepDisabled(stepNumber)
    {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber))
      {
        return null;
      }

      var disabled = false;

      for (var i = 1; i < stepNumber; i++)
      {
        if (!isStepValid(i))
        {
          disabled = true;
          break;
        }
      }

      return disabled;
    }

    /**
     * Check if the given step is optional
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepOptional(stepNumber)
    {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber))
      {
        return null;
      }

      return vm.steps[stepNumber - 1].scope.optionalStep;
    }

    /**
     * Check if the given step is hidden
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepHidden(stepNumber)
    {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber))
      {
        return null;
      }

      return !!vm.steps[stepNumber - 1].scope.hideStep;
    }

    /**
     * Check if the given step is hidden as a filter
     *
     * @param step
     * @returns {boolean}
     */
    function filterHiddenStep(step)
    {
      return !isStepHidden(step.stepNumber);
    }

    /**
     * Check if the given step is valid
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepValid(stepNumber)
    {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber))
      {
        return null;
      }

      // If the step is optional, always return true
      if (isStepOptional(stepNumber))
      {
        return true;
      }

      return vm.steps[stepNumber - 1].form.$valid;
    }

    /**
     * Check if the given step number is a valid step number
     *
     * @param stepNumber
     * @returns {boolean}
     */
    function isStepNumberValid(stepNumber)
    {
      return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
    }

    /**
     * Check if the entire form is valid
     *
     * @returns {boolean}
     */
    function isFormValid()
    {
      return vm.mainForm.$valid;
    }
  }

  /** @ngInject */
  function msHorizontalStepperDirective()
  {
    return {
      restrict: 'A',
      scope: {},
      require: ['form', 'msHorizontalStepper'],
      priority: 1001,
      controller: 'MsStepperController as MsStepper',
      bindToController: {
        model: '=ngModel'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
      compile: function (tElement)
      {
        tElement.addClass('ms-stepper');

        return function postLink(scope, iElement, iAttrs, ctrls)
        {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Register the main form and setup
          // the steps for the first time
          MsStepperCtrl.setOrientation('horizontal');
          MsStepperCtrl.registerMainForm(FormCtrl);
          MsStepperCtrl.setupSteps();
        };
      }
    };
  }

  /** @ngInject */
  function msHorizontalStepperStepDirective()
  {
    return {
      restrict: 'E',
      require: ['form', '^msHorizontalStepper'],
      priority: 1000,
      scope: {
        step: '=?',
        stepTitle: '=?',
        stepTitleTranslate: '=?',
        optionalStep: '=?',
        hideStep: '=?'
      },
      compile: function (tElement)
      {
        tElement.addClass('ms-stepper-step');

        return function postLink(scope, iElement, iAttrs, ctrls)
        {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Is it an optional step?
          scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

          // Register the step
          MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

          // Hide the step by default
          iElement.hide();
        };
      }
    };
  }

  /** @ngInject */
  function msVerticalStepperDirective($timeout)
  {
    return {
      restrict: 'A',
      scope: {},
      require: ['form', 'msVerticalStepper'],
      priority: 1001,
      controller: 'MsStepperController as MsStepper',
      bindToController: {
        model: '=ngModel'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
      compile: function (tElement)
      {
        tElement.addClass('ms-stepper');

        return function postLink(scope, iElement, iAttrs, ctrls)
        {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Register the main form and setup
          // the steps for the first time

          // Timeout is required in vertical stepper
          // as we are using transclusion in steps.
          // We have to wait for them to be transcluded
          // and registered to the controller
          $timeout(function ()
          {
            MsStepperCtrl.setOrientation('vertical');
            MsStepperCtrl.registerMainForm(FormCtrl);
            MsStepperCtrl.setupSteps();
          });
        };
      }
    };
  }

  /** @ngInject */
  function msVerticalStepperStepDirective()
  {
    return {
      restrict: 'E',
      require: ['form', '^msVerticalStepper'],
      priority: 1000,
      scope: {
        step: '=?',
        stepTitle: '=?',
        stepTitleTranslate: '=?',
        optionalStep: '=?',
        hideStep: '=?'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
      compile: function (tElement)
      {
        tElement.addClass('ms-stepper-step');

        return function postLink(scope, iElement, iAttrs, ctrls)
        {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Is it an optional step?
          scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

          // Register the step
          scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

          // Expose the controller to the scope
          scope.MsStepper = MsStepperCtrl;

          // Hide the step content by default
          iElement.find('.ms-stepper-step-content').hide();
        };
      }
    };
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .directive('msSplashScreen', msSplashScreenDirective);

  /** @ngInject */
  function msSplashScreenDirective($animate)
  {
    return {
      restrict: 'E',
      link: function (scope, iElement)
      {
        var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
        {
          $animate.leave(iElement).then(function ()
          {
            // De-register scope event
            splashScreenRemoveEvent();

            // Null-ify everything else
            scope = iElement = null;
          });
        });
      }
    };
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .directive('msSidenavHelper', msSidenavHelperDirective);

  /** @ngInject */
  function msSidenavHelperDirective()
  {
    return {
      restrict: 'A',
      require: '^mdSidenav',
      link: function (scope, iElement, iAttrs, MdSidenavCtrl)
      {
        // Watch md-sidenav open & locked open statuses
        // and add class to the ".page-layout" if only
        // the sidenav open and NOT locked open
        scope.$watch(function ()
        {
          return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
        }, function (current)
        {
          if (angular.isUndefined(current))
          {
            return;
          }

          iElement.parent().toggleClass('full-height', current);
          angular.element('html').toggleClass('sidenav-open', current);
        });
      }
    };
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .provider('msScrollConfig', msScrollConfigProvider)
    .directive('msScroll', msScrollDirective);

  /** @ngInject */
  function msScrollConfigProvider()
  {
    // Default configuration
    var defaultConfiguration = {
      wheelSpeed: 1,
      wheelPropagation: false,
      swipePropagation: true,
      minScrollbarLength: null,
      maxScrollbarLength: null,
      useBothWheelAxes: false,
      useKeyboard: true,
      suppressScrollX: false,
      suppressScrollY: false,
      scrollXMarginOffset: 0,
      scrollYMarginOffset: 0,
      stopPropagationOnClick: true
    };

    // Methods
    this.config = config;

    //////////

    /**
     * Extend default configuration with the given one
     *
     * @param configuration
     */
    function config(configuration)
    {
      defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
    }

    /**
     * Service
     */
    this.$get = function ()
    {
      var service = {
        getConfig: getConfig
      };

      return service;

      //////////

      /**
       * Return the config
       */
      function getConfig()
      {
        return defaultConfiguration;
      }
    };
  }

  /** @ngInject */
  function msScrollDirective($timeout, msScrollConfig, msUtils)
  {
    return {
      restrict: 'AE',
      compile: function (tElement)
      {
        // Add class
        tElement.addClass('ms-scroll');

        return function postLink(scope, iElement, iAttrs)
        {
          var options = {};

          // If options supplied, evaluate the given
          // value. This is because we don't want to
          // have an isolated scope but still be able
          // to use scope variables.
          // We don't want an isolated scope because
          // we should be able to use this everywhere
          // especially with other directives
          if (iAttrs.msScroll)
          {
            options = scope.$eval(iAttrs.msScroll);
          }

          // Extend the given config with the ones from provider
          options = angular.extend({}, msScrollConfig.getConfig(), options);

          // Initialize the scrollbar
          $timeout(function ()
          {
            PerfectScrollbar.initialize(iElement[0], options);
          }, 0);

          // Update the scrollbar on element mouseenter
          iElement.on('mouseenter', updateScrollbar);

          // Watch scrollHeight and update
          // the scrollbar if it changes
          scope.$watch(function ()
          {
            return iElement.prop('scrollHeight');
          }, function (current, old)
          {
            if (angular.isUndefined(current) || angular.equals(current, old))
            {
              return;
            }

            updateScrollbar();
          });

          // Watch scrollWidth and update
          // the scrollbar if it changes
          scope.$watch(function ()
          {
            return iElement.prop('scrollWidth');
          }, function (current, old)
          {
            if (angular.isUndefined(current) || angular.equals(current, old))
            {
              return;
            }

            updateScrollbar();
          });

          /**
           * Update the scrollbar
           */
          function updateScrollbar()
          {
            PerfectScrollbar.update(iElement[0]);
          }

          // Cleanup on destroy
          scope.$on('$destroy', function ()
          {
            iElement.off('mouseenter');
            PerfectScrollbar.destroy(iElement[0]);
          });
        };
      }
    };
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .directive('msResponsiveTable', msResponsiveTableDirective);

  /** @ngInject */
  function msResponsiveTableDirective()
  {
    return {
      restrict: 'A',
      link: function (scope, iElement)
      {
        // Wrap the table
        var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
        iElement.after(wrapper);
        wrapper.append(iElement);

        //////////
      }
    };
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .directive('msRandomClass', msRandomClassDirective);

  /** @ngInject */
  function msRandomClassDirective()
  {
    return {
      restrict: 'A',
      scope: {
        msRandomClass: '='
      },
      link: function (scope, iElement)
      {
        var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
        iElement.addClass(randomClass);
      }
    };
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .factory('msNavFoldService', msNavFoldService)
    .directive('msNavIsFolded', msNavIsFoldedDirective)
    .controller('MsNavController', MsNavController)
    .directive('msNav', msNavDirective)
    .directive('msNavTitle', msNavTitleDirective)
    .directive('msNavButton', msNavButtonDirective)
    .directive('msNavToggle', msNavToggleDirective);

  /** @ngInject */
  function msNavFoldService()
  {
    var foldable = {};

    var service = {
      setFoldable: setFoldable,
      isNavFoldedOpen: isNavFoldedOpen,
      toggleFold: toggleFold,
      openFolded: openFolded,
      closeFolded: closeFolded
    };

    return service;

    //////////

    /**
     * Set the foldable
     *
     * @param scope
     * @param element
     */
    function setFoldable(scope, element)
    {
      foldable = {
        'scope': scope,
        'element': element
      };
    }

    /**
     * Is folded open
     */
    function isNavFoldedOpen()
    {
      return foldable.scope.isNavFoldedOpen();
    }

    /**
     * Toggle fold
     */
    function toggleFold()
    {
      foldable.scope.toggleFold();
    }

    /**
     * Open folded navigation
     */
    function openFolded()
    {
      foldable.scope.openFolded();
    }

    /**
     * Close folded navigation
     */
    function closeFolded()
    {
      foldable.scope.closeFolded();
    }
  }

  /** @ngInject */
  function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
  {
    return {
      restrict: 'A',
      link: function (scope, iElement, iAttrs)
      {
        var isFolded = (iAttrs.msNavIsFolded === 'true'),
          isFoldedOpen = false,
          body = angular.element($document[0].body),
          openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
          closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
          sidenavEl = iElement.parent();

        // Initialize the service
        msNavFoldService.setFoldable(scope, iElement, isFolded);

        // Set the fold status for the first time
        if (isFolded)
        {
          fold();
        }
        else
        {
          unfold();
        }

        /**
         * Is nav folded open
         */
        function isNavFoldedOpen()
        {
          return isFoldedOpen;
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
          isFolded = !isFolded;

          if (isFolded)
          {
            fold();
          }
          else
          {
            unfold();
          }
        }

        /**
         * Fold the navigation
         */
        function fold()
        {
          // Add classes
          body.addClass('ms-nav-folded');

          // Collapse everything and scroll to the top
          $rootScope.$broadcast('msNav::forceCollapse');
          iElement.scrollTop(0);

          // Append the openOverlay to the element
          sidenavEl.append(openOverlay);

          // Event listeners
          openOverlay.on('mouseenter touchstart', function (event)
          {
            openFolded(event);
            isFoldedOpen = true;
          });
        }

        /**
         * Open folded navigation
         */
        function openFolded(event)
        {
          if (angular.isDefined(event))
          {
            event.preventDefault();
          }

          body.addClass('ms-nav-folded-open');

          // Update the location
          $rootScope.$broadcast('msNav::expandMatchingToggles');

          // Remove open overlay
          sidenavEl.find(openOverlay).remove();

          // Append close overlay and bind its events
          sidenavEl.parent().append(closeOverlay);
          closeOverlay.on('mouseenter touchstart', function (event)
          {
            closeFolded(event);
            isFoldedOpen = false;
          });
        }

        /**
         * Close folded navigation
         */
        function closeFolded(event)
        {
          if (angular.isDefined(event))
          {
            event.preventDefault();
          }

          // Collapse everything and scroll to the top
          $rootScope.$broadcast('msNav::forceCollapse');
          iElement.scrollTop(0);

          body.removeClass('ms-nav-folded-open');

          // Remove close overlay
          sidenavEl.parent().find(closeOverlay).remove();

          // Append open overlay and bind its events
          sidenavEl.append(openOverlay);
          openOverlay.on('mouseenter touchstart', function (event)
          {
            openFolded(event);
            isFoldedOpen = true;
          });
        }

        /**
         * Unfold the navigation
         */
        function unfold()
        {
          body.removeClass('ms-nav-folded ms-nav-folded-open');

          // Update the location
          $rootScope.$broadcast('msNav::expandMatchingToggles');

          iElement.off('mouseenter mouseleave');
        }

        // Expose functions to the scope
        scope.toggleFold = toggleFold;
        scope.openFolded = openFolded;
        scope.closeFolded = closeFolded;
        scope.isNavFoldedOpen = isNavFoldedOpen;

        // Cleanup
        scope.$on('$destroy', function ()
        {
          openOverlay.off('mouseenter touchstart');
          closeOverlay.off('mouseenter touchstart');
          iElement.off('mouseenter mouseleave');
        });
      }
    };
  }


  /** @ngInject */
  function MsNavController()
  {
    var vm = this,
      disabled = false,
      toggleItems = [],
      lockedItems = [];

    // Data

    // Methods
    vm.isDisabled = isDisabled;
    vm.enable = enable;
    vm.disable = disable;
    vm.setToggleItem = setToggleItem;
    vm.getLockedItems = getLockedItems;
    vm.setLockedItem = setLockedItem;
    vm.clearLockedItems = clearLockedItems;

    //////////

    /**
     * Is navigation disabled
     *
     * @returns {boolean}
     */
    function isDisabled()
    {
      return disabled;
    }

    /**
     * Disable the navigation
     */
    function disable()
    {
      disabled = true;
    }

    /**
     * Enable the navigation
     */
    function enable()
    {
      disabled = false;
    }

    /**
     * Set toggle item
     *
     * @param element
     * @param scope
     */
    function setToggleItem(element, scope)
    {
      toggleItems.push({
        'element': element,
        'scope': scope
      });
    }

    /**
     * Get locked items
     *
     * @returns {Array}
     */
    function getLockedItems()
    {
      return lockedItems;
    }

    /**
     * Set locked item
     *
     * @param element
     * @param scope
     */
    function setLockedItem(element, scope)
    {
      lockedItems.push({
        'element': element,
        'scope': scope
      });
    }

    /**
     * Clear locked items list
     */
    function clearLockedItems()
    {
      lockedItems = [];
    }
  }

  /** @ngInject */
  function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
  {
    return {
      restrict: 'E',
      scope: {},
      controller: 'MsNavController',
      compile: function (tElement)
      {
        tElement.addClass('ms-nav');

        return function postLink(scope)
        {
          // Update toggle status according to the ui-router current state
          $rootScope.$broadcast('msNav::expandMatchingToggles');

          // Update toggles on state changes
          var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
          {
            $rootScope.$broadcast('msNav::expandMatchingToggles');

            // Close navigation sidenav on stateChangeSuccess
            $mdComponentRegistry.when('navigation').then(function (navigation)
            {
              navigation.close();

              if (msNavFoldService.isNavFoldedOpen())
              {
                msNavFoldService.closeFolded();
              }
            });
          });

          // Cleanup
          scope.$on('$destroy', function ()
          {
            stateChangeSuccessEvent();
          });
        };
      }
    };
  }

  /** @ngInject */
  function msNavTitleDirective()
  {
    return {
      restrict: 'A',
      compile: function (tElement)
      {
        tElement.addClass('ms-nav-title');

        return function postLink()
        {

        };
      }
    };
  }

  /** @ngInject */
  function msNavButtonDirective()
  {
    return {
      restrict: 'AE',
      compile: function (tElement)
      {
        tElement.addClass('ms-nav-button');

        return function postLink()
        {

        };
      }
    };
  }

  /** @ngInject */
  function msNavToggleDirective($rootScope, $q, $animate, $state)
  {
    return {
      restrict: 'A',
      require: '^msNav',
      scope: true,
      compile: function (tElement, tAttrs)
      {
        tElement.addClass('ms-nav-toggle');

        // Add collapsed attr
        if (angular.isUndefined(tAttrs.collapsed))
        {
          tAttrs.collapsed = true;
        }

        tElement.attr('collapsed', tAttrs.collapsed);

        return function postLink(scope, iElement, iAttrs, MsNavCtrl)
        {
          var classes = {
            expanded: 'expanded',
            expandAnimation: 'expand-animation',
            collapseAnimation: 'collapse-animation'
          };

          // Store all related states
          var links = iElement.find('a');
          var states = [];
          var regExp = /\(.*\)/g;

          angular.forEach(links, function (link)
          {
            var state = angular.element(link).attr('ui-sref');

            if (angular.isUndefined(state))
            {
              return;
            }

            // Remove any parameter definition from the state name before storing it
            state = state.replace(regExp, '');

            states.push(state);
          });

          // Store toggle-able element and its scope in the main nav controller
          MsNavCtrl.setToggleItem(iElement, scope);

          // Click handler
          iElement.children('.ms-nav-button').on('click', toggle);

          // Toggle function
          function toggle()
          {
            // If navigation is disabled, do nothing...
            if (MsNavCtrl.isDisabled())
            {
              return;
            }

            // Disable the entire navigation to prevent spamming
            MsNavCtrl.disable();

            if (isCollapsed())
            {
              // Clear the locked items list
              MsNavCtrl.clearLockedItems();

              // Emit pushToLockedList event
              scope.$emit('msNav::pushToLockedList');

              // Collapse everything but locked items
              $rootScope.$broadcast('msNav::collapse');

              // Expand and then...
              expand().then(function ()
              {
                // Enable the entire navigation after animations completed
                MsNavCtrl.enable();
              });
            }
            else
            {
              // Collapse with all children
              scope.$broadcast('msNav::forceCollapse');
            }
          }

          // Cleanup
          scope.$on('$destroy', function ()
          {
            iElement.children('.ms-nav-button').off('click');
          });

          /*---------------------*/
          /* Scope Events        */
          /*---------------------*/

          /**
           * Collapse everything but locked items
           */
          scope.$on('msNav::collapse', function ()
          {
            // Only collapse toggles that are not locked
            var lockedItems = MsNavCtrl.getLockedItems();
            var locked = false;

            angular.forEach(lockedItems, function (lockedItem)
            {
              if (angular.equals(lockedItem.scope, scope))
              {
                locked = true;
              }
            });

            if (locked)
            {
              return;
            }

            // Collapse and then...
            collapse().then(function ()
            {
              // Enable the entire navigation after animations completed
              MsNavCtrl.enable();
            });
          });

          /**
           * Collapse everything
           */
          scope.$on('msNav::forceCollapse', function ()
          {
            // Collapse and then...
            collapse().then(function ()
            {
              // Enable the entire navigation after animations completed
              MsNavCtrl.enable();
            });
          });

          /**
           * Expand toggles that match with the current states
           */
          scope.$on('msNav::expandMatchingToggles', function ()
          {
            var currentState = $state.current.name;
            var shouldExpand = false;

            angular.forEach(states, function (state)
            {
              if (currentState === state)
              {
                shouldExpand = true;
              }
            });

            if (shouldExpand)
            {
              expand();
            }
            else
            {
              collapse();
            }
          });

          /**
           * Add toggle to the locked list
           */
          scope.$on('msNav::pushToLockedList', function ()
          {
            // Set expanded item on main nav controller
            MsNavCtrl.setLockedItem(iElement, scope);
          });

          /*---------------------*/
          /* Internal functions  */
          /*---------------------*/

          /**
           * Is element collapsed
           *
           * @returns {bool}
           */
          function isCollapsed()
          {
            return iElement.attr('collapsed') === 'true';
          }

          /**
           * Is element expanded
           *
           * @returns {bool}
           */
          function isExpanded()
          {
            return !isCollapsed();
          }

          /**
           * Expand the toggle
           *
           * @returns $promise
           */
          function expand()
          {
            // Create a new deferred object
            var deferred = $q.defer();

            // If the menu item is already expanded, do nothing..
            if (isExpanded())
            {
              // Reject the deferred object
              deferred.reject({'error': true});

              // Return the promise
              return deferred.promise;
            }

            // Set element attr
            iElement.attr('collapsed', false);

            // Grab the element to expand
            var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

            // Move the element out of the dom flow and
            // make it block so we can get its height
            elementToExpand.css({
              'position': 'absolute',
              'visibility': 'hidden',
              'display': 'block',
              'height': 'auto'
            });

            // Grab the height
            var height = elementToExpand[0].offsetHeight;

            // Reset the style modifications
            elementToExpand.css({
              'position': '',
              'visibility': '',
              'display': '',
              'height': ''
            });

            // Animate the height
            scope.$evalAsync(function ()
            {
              $animate.animate(elementToExpand,
                {
                  'display': 'block',
                  'height': '0px'
                },
                {
                  'height': height + 'px'
                },
                classes.expandAnimation
              ).then(
                function ()
                {
                  // Add expanded class
                  elementToExpand.addClass(classes.expanded);

                  // Clear the inline styles after animation done
                  elementToExpand.css({'height': ''});

                  // Resolve the deferred object
                  deferred.resolve({'success': true});
                }
              );
            });

            // Return the promise
            return deferred.promise;
          }

          /**
           * Collapse the toggle
           *
           * @returns $promise
           */
          function collapse()
          {
            // Create a new deferred object
            var deferred = $q.defer();

            // If the menu item is already collapsed, do nothing..
            if (isCollapsed())
            {
              // Reject the deferred object
              deferred.reject({'error': true});

              // Return the promise
              return deferred.promise;
            }

            // Set element attr
            iElement.attr('collapsed', true);

            // Grab the element to collapse
            var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

            // Grab the height
            var height = elementToCollapse[0].offsetHeight;

            // Animate the height
            scope.$evalAsync(function ()
            {
              $animate.animate(elementToCollapse,
                {
                  'height': height + 'px'
                },
                {
                  'height': '0px'
                },
                classes.collapseAnimation
              ).then(
                function ()
                {
                  // Remove expanded class
                  elementToCollapse.removeClass(classes.expanded);

                  // Clear the inline styles after animation done
                  elementToCollapse.css({
                    'display': '',
                    'height': ''
                  });

                  // Resolve the deferred object
                  deferred.resolve({'success': true});
                }
              );
            });

            // Return the promise
            return deferred.promise;
          }
        };
      }
    };
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .controller('msMasonryController', msMasonryController)
    .directive('msMasonry', msMasonry)
    .directive('msMasonryItem', msMasonryItem);

  /** @ngInject */
  function msMasonryController($scope, $window, $mdMedia, $timeout)
  {
    var vm = this,
      defaultOpts = {
        columnCount: 5,
        respectItemOrder: false,
        reLayoutDebounce: 400,
        responsive: {
          md: 3,
          sm: 2,
          xs: 1
        }
      },
      reLayoutTimeout = true;

    vm.options = null;
    vm.container = [];
    vm.containerPos = '';
    vm.columnWidth = '';
    vm.items = [];

    // Methods
    vm.reLayout = reLayout;
    vm.initialize = initialize;
    vm.waitImagesLoaded = waitImagesLoaded;

    function initialize()
    {
      vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


      watchContainerResize();
    }

    $scope.$on('msMasonry:relayout', function ()
    {
      reLayout();
    });

    function waitImagesLoaded(element, callback)
    {
      if (typeof imagesLoaded !== 'undefined')
      {
        var imgLoad = $window.imagesLoaded(element);

        imgLoad.on('done', function ()
        {
          callback();
        });
      }
      else
      {
        callback();
      }
    }

    function watchContainerResize()
    {
      $scope.$watch(
        function ()
        {
          return vm.container.width();
        },
        function (newValue, oldValue)
        {
          if (newValue !== oldValue)
          {
            reLayout();
          }
        }
      );
    }

    function reLayout()
    {
      // Debounce for relayout
      if (reLayoutTimeout)
      {
        $timeout.cancel(reLayoutTimeout);
      }

      reLayoutTimeout = $timeout(function ()
      {
        start();

        $scope.$broadcast('msMasonry:relayoutFinished');

      }, vm.options.reLayoutDebounce);

      // Start relayout
      function start()
      {
        vm.containerPos = vm.container[0].getBoundingClientRect();

        updateColumnOptions();

        $scope.$broadcast('msMasonry:relayoutStarted');

        vm.items = vm.container.find('ms-masonry-item');

        //initialize lastRowBottomArr
        var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
        {
          return 0;
        });

        // set item positions
        for (var i = 0; i < vm.items.length; i++)
        {
          var item = vm.items[i],
            xPos, yPos, column, refTop;

          item = angular.element(item);

          if (item.scope())
          {
            item.scope().$broadcast('msMasonryItem:startReLayout');
          }

          item.css({'width': vm.columnWidth});

          if (vm.options.respectItemOrder)
          {
            column = i % vm.columnCount;
            refTop = referenceArr[column];
          }
          else
          {
            refTop = Math.min.apply(Math, referenceArr);
            column = referenceArr.indexOf(refTop);
          }

          referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

          xPos = Math.round(column * vm.columnWidth);
          yPos = refTop;

          item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
          item.addClass('placed');

          if (item.scope())
          {
            item.scope().$broadcast('msMasonryItem:finishReLayout');
          }
        }
      }
    }

    function updateColumnOptions()
    {
      vm.columnCount = vm.options.columnCount;

      if ($mdMedia('gt-md'))
      {
        vm.columnCount = vm.options.columnCount;
      }
      else if ($mdMedia('md'))
      {
        vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
      }
      else if ($mdMedia('sm'))
      {
        vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
      }
      else
      {
        vm.columnCount = vm.options.responsive.xs;
      }

      vm.columnWidth = vm.containerPos.width / vm.columnCount;

    }
  }

  /** @ngInject */
  function msMasonry($timeout)
  {
    return {
      restrict: 'AEC',
      controller: 'msMasonryController',
      compile: compile
    };
    function compile(element, attributes)
    {
      return {
        pre: function preLink(scope, iElement, iAttrs, controller)
        {
          controller.options = angular.fromJson(attributes.options || '{}');
          controller.container = element;
        },
        post: function postLink(scope, iElement, iAttrs, controller)
        {
          $timeout(function ()
          {
            controller.initialize();
          });
        }
      };
    }
  }

  /** @ngInject */
  function msMasonryItem()
  {
    return {
      restrict: 'AEC',
      require: '^msMasonry',
      priority: 1,
      link: link
    };

    function link(scope, element, attributes, controller)
    {
      controller.waitImagesLoaded(element, function ()
      {
        controller.reLayout();

      });

      scope.$on('msMasonryItem:finishReLayout', function ()
      {
        scope.$watch(function ()
        {
          return element.height();
        }, function (newVal, oldVal)
        {
          if (newVal !== oldVal)
          {
            controller.reLayout();
          }
        });
      });

      element.on('$destroy', function ()
      {
        controller.reLayout();
      });
    }
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .directive('msInfoBar', msInfoBarDirective);

  /** @ngInject */
  function msInfoBarDirective($document)
  {
    return {
      restrict: 'E',
      scope: {},
      transclude: true,
      templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
      link: function (scope, iElement)
      {
        var body = $document.find('body'),
          bodyClass = 'ms-info-bar-active';

        // Add body class
        body.addClass(bodyClass);

        /**
         * Remove the info bar
         */
        function removeInfoBar()
        {
          body.removeClass(bodyClass);
          iElement.remove();
          scope.$destroy();
        }

        // Expose functions
        scope.removeInfoBar = removeInfoBar;
      }
    };
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .controller('MsFormWizardController', MsFormWizardController)
    .directive('msFormWizard', msFormWizardDirective)
    .directive('msFormWizardForm', msFormWizardFormDirective);

  /** @ngInject */
  function MsFormWizardController()
  {
    var vm = this;

    // Data
    vm.forms = [];
    vm.selectedIndex = 0;

    // Methods
    vm.registerForm = registerForm;

    vm.previousStep = previousStep;
    vm.nextStep = nextStep;
    vm.firstStep = firstStep;
    vm.lastStep = lastStep;

    vm.totalSteps = totalSteps;
    vm.isFirstStep = isFirstStep;
    vm.isLastStep = isLastStep;

    vm.currentStepInvalid = currentStepInvalid;
    vm.previousStepInvalid = previousStepInvalid;
    vm.formsIncomplete = formsIncomplete;
    vm.resetForm = resetForm;

    //////////

    /**
     * Register form
     *
     * @param form
     */
    function registerForm(form)
    {
      vm.forms.push(form);
    }

    /**
     * Go to previous step
     */
    function previousStep()
    {
      if (isFirstStep())
      {
        return;
      }

      vm.selectedIndex--;
    }

    /**
     * Go to next step
     */
    function nextStep()
    {
      if (isLastStep())
      {
        return;
      }

      vm.selectedIndex++;
    }

    /**
     * Go to first step
     */
    function firstStep()
    {
      vm.selectedIndex = 0;
    }

    /**
     * Go to last step
     */
    function lastStep()
    {
      vm.selectedIndex = totalSteps() - 1;
    }

    /**
     * Return total steps
     *
     * @returns {int}
     */
    function totalSteps()
    {
      return vm.forms.length;
    }

    /**
     * Is first step?
     *
     * @returns {boolean}
     */
    function isFirstStep()
    {
      return vm.selectedIndex === 0;
    }

    /**
     * Is last step?
     *
     * @returns {boolean}
     */
    function isLastStep()
    {
      return vm.selectedIndex === totalSteps() - 1;
    }

    /**
     * Is current step invalid?
     *
     * @returns {boolean}
     */
    function currentStepInvalid()
    {
      return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
    }

    /**
     * Is previous step invalid?
     *
     * @returns {boolean}
     */
    function previousStepInvalid()
    {
      return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) &&
        vm.forms[vm.selectedIndex - 1].$invalid;
    }

    /**
     * Check if there is any incomplete forms
     *
     * @returns {boolean}
     */
    function formsIncomplete()
    {
      for (var x = 0; x < vm.forms.length; x++)
      {
        if (vm.forms[x].$invalid)
        {
          return true;
        }
      }

      return false;
    }

    /**
     * Reset form
     */
    function resetForm()
    {
      // Go back to the first step
      vm.selectedIndex = 0;

      // Make sure all the forms are back in the $pristine & $untouched status
      for (var x = 0; x < vm.forms.length; x++)
      {
        vm.forms[x].$setPristine();
        vm.forms[x].$setUntouched();
      }
    }
  }

  /** @ngInject */
  function msFormWizardDirective()
  {
    return {
      restrict: 'E',
      scope: true,
      controller: 'MsFormWizardController as msWizard',
      compile: function (tElement)
      {
        tElement.addClass('ms-form-wizard');

        return function postLink()
        {

        };
      }
    };
  }

  /** @ngInject */
  function msFormWizardFormDirective()
  {
    return {
      restrict: 'A',
      require: ['form', '^msFormWizard'],
      compile: function (tElement)
      {
        tElement.addClass('ms-form-wizard-form');

        return function postLink(scope, iElement, iAttrs, ctrls)
        {
          var formCtrl = ctrls[0],
            MsFormWizardCtrl = ctrls[1];

          MsFormWizardCtrl.registerForm(formCtrl);
        };
      }
    };
  }

})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
    .directive('msDatepickerFix', msDatepickerFix);

  /** @ngInject */
  function msDatepickerFixConfigProvider()
  {
    var service = this;

    // Default configuration
    var defaultConfig = {
      // To view
      formatter: function (val)
      {
        if (!val)
        {
          return '';
        }

        return val === '' ? val : new Date(val);
      },
      // To model
      parser: function (val)
      {
        if (!val)
        {
          return '';
        }

        return moment(val).add(moment(val).utcOffset(), 'm').toDate();
      }
    };

    // Methods
    service.config = config;

    //////////

    /**
     * Extend default configuration with the given one
     *
     * @param configuration
     */
    function config(configuration)
    {
      defaultConfig = angular.extend({}, defaultConfig, configuration);
    }

    /**
     * Service
     */
    service.$get = function ()
    {
      return defaultConfig;
    };
  }

  /** @ngInject */
  function msDatepickerFix(msDatepickerFixConfig)
  {
    return {
      require: 'ngModel',
      priority: 1,
      link: function (scope, elem, attrs, ngModel)
      {
        ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
        ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
      }
    };
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .directive('msCard', msCardDirective);

  /** @ngInject */
  function msCardDirective()
  {
    return {
      restrict: 'E',
      scope: {
        templatePath: '=template',
        card: '=ngModel',
        vm: '=viewModel'
      },
      template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
      compile: function (tElement)
      {
        // Add class
        tElement.addClass('ms-card');

        return function postLink(scope, iElement)
        {
          // Methods
          scope.cardTemplateLoaded = cardTemplateLoaded;

          //////////

          /**
           * Emit cardTemplateLoaded event
           */
          function cardTemplateLoaded()
          {
            scope.$emit('msCard::cardTemplateLoaded', iElement);
          }
        };
      }
    };
  }
})();

(function ()
{
  'use strict';

  angular
    .module('dbs.offer')
    .controller('OfferCardController', OfferCardController);

  /** @ngInject */
  function OfferCardController($scope, $rootScope, i18nService, favoriteService, $state)
  {
    var cvm = angular.merge(this, {
      cardMouseOver: cardMouseOver,
      cardMouseOut: cardMouseOut,
      addToFavorite: addToFavorite,
      redeemOffer: redeemOffer,
      goToOffer: goToOffer
    });

    function goToOffer(offerCode)
    {
      $("#favorite-modal").modal("hide");
      $state.go('dbs.offer', {code: offerCode});
    }
    function cardMouseOver($event)
    {
      $(".offer-card-front.blurred").removeClass("blurred");
      $(".offer-card-back.shown").removeClass("shown");

      var $card = $($event.target).parents(".offer-card");
      var $cardBack = $card.find(".offer-card-back");
      var $cardFront = $card.find(".offer-card-front");
      $cardBack.addClass("shown");
      $cardFront.addClass("blurred");

    }

    function cardMouseOut($event)
    {
      var $card = $($event.target).parents(".offer-card");
      var $cardBack = $card.find(".offer-card-back");
      var $cardFront = $card.find(".offer-card-front");
      $cardBack.removeClass("shown");
      $cardFront.removeClass("blurred");
    }

    function addToFavorite(offerCode)
    {
      favoriteService.add(offerCode)
    }

    function redeemOffer(offerCode, offerName, $event)
    {
      var offerNameTranslated = i18nService.getTrans(offerName, 'en');
      window.open(
        $rootScope._data.website.redeemFormPageUrl + "?lang=" + $rootScope.lang + "&offer_id=" +
        encodeURIComponent(offerCode) + "&offer_name=" +
        encodeURIComponent(offerNameTranslated), '_blank');
      favoriteService.redeemed.add(offerCode);
    }
  }
})();

(function ()
{
  'use strict';

  angular
    .module('dbs.home', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $urlRouterProvider)
  {
    // State
    $stateProvider
      .state('dbs.home', {
        url: '/home',
        views: {
          'content@dbs': {
            templateUrl: 'app/dbs/home/home.html',
            controller: 'HomeController as vm'
          }
        }
      })
      .state('dbs.home.scroll', {
        url: '/:scrollTo',
        views: {
          'content@dbs': {
            templateUrl: 'app/dbs/home/home.html',
            controller: 'HomeController as vm'
          }
        },
        resolve: {
          scrollTo: function ($rootScope, $stateParams, $state, $timeout, $q)
          {
            var d = $q.defer();
            $timeout(function ()
            {
              $rootScope.scrollTo = {scrollTo: $stateParams.scrollTo};
              d.reject({redirect: "dbs.home"});
            });
            return d.promise;
          }
        }
      });
    $urlRouterProvider
      .when('', '/home')

  }
})();

(function ()
{
  'use strict';

  angular
    .module('dbs.home')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($scope, $stateParams, $document, $timeout, i18nService, recommendedService,
                          localStorageService, Carousel, $window)
  {

    var autoplay = true;
    // var options = {
    //   duration: 700,
    //   easing: 'easeInQuad',
    //   offset: 120,
    //   callbackBefore: function (element)
    //   {
    //     console.log('about to scroll to element', element);
    //   },
    //   callbackAfter: function (element)
    //   {
    //     console.log('scrolled to element', element);
    //   }
    // };


    // smoothScroll(element, options);
    // Data
    var defaultCat = {code: "all", name: "home.all_offers.search.all_categories"};//todo:do translation
    var $select;
    var sliderSlickConfig = {
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      speed: 1000,
      autoplaySpeed: 5000,
      arrows: true,
      dots: true,
      dotsClass: 'slick-dots list-unstyled',
      autoplay: autoplay,
      draggable: true,

      enabled: false,
      appendArrows: ".slider-prev-next",
      prevArrow: '.slick-slider-prev',
      nextArrow: '.slick-slider-next',
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    var trendingOffersSlickConfig = {
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      touchCssEase: 'ease',
      speed: 800,
      touchSpeed: 500,
      autoplaySpeed: 3000,
      arrows: true,
      autoplay: autoplay,
      draggable: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,

      enabled: false,
      appendArrows: ".rectren-prev-next",
      prevArrow: '.rectren-prev',
      nextArrow: '.rectren-next',

    };
    trendingOffersSlickConfig.slidesToShow = getSlideToShow();
    Carousel.setOptions(trendingOffersSlickConfig);

    function getSlideToShow()
    {

      var width = $window.innerWidth, ss;
      if (width < 680)
      {
        ss = "xsm";
      } else if (width < 1247)
      {
        ss = "md";
      } else
      {
        ss = "lg";
      }

      switch (ss)
      {
        case "xsm":
          return 1;
        case "md":
          return 2;
        case "lg":
          return 3;
      }
    }

    angular.element($window).bind('resize', function ()
    {
      var screenSize = getSlideToShow();

      if (screenSize !== trendingOffersSlickConfig.slidesToShow)
      {
        trendingOffersSlickConfig.slidesToShow = getSlideToShow();
        Carousel.setOptions(trendingOffersSlickConfig);
        // manuall $digest required as resize event
        // is outside of angular
        $scope.$digest();
      }

    });

    var recomOffersSlickConfig = angular.merge({}, trendingOffersSlickConfig, {
      // appendArrows: ".recom-prev-next",
      // prevArrow: '.slick-rectren-prev',
      // nextArrow: '.slick-rectren-next'
    });

    // View
    var vm = angular.merge(this, {
      offers: $scope.$root._data.offers,

      sliders: $scope.$root._data.sliders,
      sliderSlickConfig: sliderSlickConfig,

      trendingOffers: $scope.$root._data.trendings,
      trendingOffersSlickConfig: trendingOffersSlickConfig,

      recomOffers: recommendedService.getAll().filter(function (x)
      {
        return x.score >= 0;
      }),
      trendingRecom: $scope.$root._data.trendings,
      recomOffersSlickConfig: recomOffersSlickConfig,
      showRecom: false,

      categorys: angular.copy($scope.$root._data.categorys),
      searchOffers: getAllOffers(),
      allLimitOffer: 12,
      allLimitOfferMobile: 3,
      search: search,
      searchForm: {search: "", category: defaultCat},
      canLoadMoreDesk: function ()
      {
        return vm.allLimitOffer >= Math.min(vm.allLimitOffer + 12, vm.searchOffers.length);
      },
      canLoadMoreMob: function ()
      {
        return vm.allLimitOfferMobile >= Math.min(vm.allLimitOfferMobile + 3, vm.searchOffers.length);
      },
      loadMore: function ()
      {
        vm.allLimitOffer = Math.min(vm.allLimitOffer + 12, vm.searchOffers.length);
        vm.allLimitOfferMobile = Math.min(vm.allLimitOfferMobile + 3, vm.searchOffers.length);
      },
      promotionImg: $scope.$root._data.website.promotionImage,
      promotionOfferLink: $scope.$root._data.website.promotionOfferLink,
      hidePromoModal: hidePromoModal,
      clickTrendingRecom: clickTrendingRecom
    });

    function clickTrendingRecom(isTrending)
    {
      vm.showRecom = !isTrending;
      vm.trendingOffersSlickConfig.enabled = isTrending;
      vm.recomOffersSlickConfig.enabled = !isTrending;
      vm.trendingRecom = isTrending ? vm.trendingOffers : vm.recomOffers;
    }

    function hidePromoModal()
    {
      $("#promo-modal").modal("hide");
      $(".modal-backdrop").fadeOut();
    }

    vm.categorys.unshift(defaultCat);

    function scrollToDivId(divId)
    {
      $timeout(function ()
      {
        var element = angular.element(document.getElementById(divId))[0];
        if (element)
        {
          $document.scrollToElement(element, 75, 600);
        }
      })

    }

    $scope.$on('$viewContentAnimationEnded', function (event)
    {
      $select = $('select').niceSelect();
      $timeout(function ()
      {
        vm.sliderSlickConfig.enabled = true;
        vm.trendingOffersSlickConfig.enabled = true;
        if (shouldShowPromo())
        {
          $timeout(function ()
          {
            $("#promo-modal").modal("show");
          }, $scope.$root._data.website.promotionDelayInSec * 1000);
        }

        $timeout(function ()
        {
          $scope.$root.$watch('scrollTo', function (newVal, oldVal)
          {
            if (newVal)
            {
              scrollToDivId(newVal.scrollTo)
            }
          });
        }, 500);
      })

    });
    // Methods

    function getAllOffers()
    {
      return angular.copy($scope.$root._data.offers);
    }

    function search($event)
    {
      var allOffers = getAllOffers();

      var searchResults = [];
      if (!vm.searchForm.search)
      {
        //if no search string, searchResults is allOffers
        searchResults = allOffers;
      }
      else
      { //if search string, searchResults is only matching offers

        //search in merchants
        searchResults = allOffers.filter(function (offer)
        {

          //search in merchants
          var isMerchantFound = false;
          if (offer.merchant)
          {
            var merchantTrans = i18nService.getTrans(offer.merchant.name);
            isMerchantFound =
              merchantTrans && merchantTrans.toLowerCase().contains(vm.searchForm.search.toLowerCase());
          }

          //search in offers name
          var nameTrans = i18nService.getTrans(offer.name);
          var isNameFound = nameTrans && nameTrans.toLowerCase().contains(vm.searchForm.search.toLowerCase());

          //search in shortDesc
          var shortDescriptionTrans = i18nService.getTrans(offer.shortDescription);
          var isShortDescriptionFound = shortDescriptionTrans &&
            shortDescriptionTrans.toLowerCase().contains(vm.searchForm.search.toLowerCase());

          //search in longDesc
          var longDescriptionTrans = i18nService.getTrans(offer.longDescription);
          var isLongDescriptionFound = longDescriptionTrans &&
            longDescriptionTrans.toLowerCase().contains(vm.searchForm.search.toLowerCase());

          return isMerchantFound || isNameFound || isShortDescriptionFound || isLongDescriptionFound;
        });
      }

      //filter searchResults by category
      if ("all" !== vm.searchForm.category.code)
      {
        searchResults = searchResults.filter(function (offer)
        {
          //try to find the category in the offer
          var category = offer.categorys.find(function (offerCat)
          {
            return offerCat.code === vm.searchForm.category.code;
          });
          return category && category.code === vm.searchForm.category.code;
        });
      }
      //deduplicate

      vm.searchOffers = searchResults
    }


    function shouldShowPromo()
    {
      var today = moment().format('YYMMDD');
      var shouldShow = shouldShow();
      if (shouldShow)
      {
        var lastShownPromo = localStorageService.set('lastShownPromo', {
          day: today,
          promotionImg: vm.promotionImg,
          promotionOfferLink: vm.promotionOfferLink
        });
      }
      return shouldShow;

      function shouldShow()
      {
        //hide on mobile & tablet
        if ($window.innerWidth < 1247)
        {
          return false;
        }

        var lastShownPromo = localStorageService.get('lastShownPromo') || {};

        //if promo disabled, hide
        if (!vm.promotionImg || !vm.promotionOfferLink)
        {
          return false
        }

        //if promo changed, display
        if (vm.promotionImg !== lastShownPromo.promotionImg ||
          vm.promotionOfferLink !== lastShownPromo.promotionOfferLink)
        {
          return true;
        }

        //if not shown today, display
        if (lastShownPromo.day === today)
        {
          return false;
        }
        //otherwise hide
        return false;
      }
    }

    //////////
  }
})();


(function ()
{
  'use strict';

  angular
    .module('dbs.header', [])
    .config(config);

  /** @ngInject */
  function config()
  {
  }
})();

(function ()
{
  'use strict';

  angular
    .module('dbs.header')
    .controller('HeaderController', HeaderController);

  /** @ngInject */
  function HeaderController($scope, favoriteService, i18nService)
  {
    var vm = angular.merge(this, {
      menuItems: [
        {
          label: "nav.all_offers",
          state: "dbs.home.scroll",
          param: {'scrollTo': 'all-offers'}
        },
        {
          label: "nav.trending_offers",
          state: "dbs.home.scroll",
          param: {'scrollTo': 'trending-offers'}
        },
        {
          label: "nav.favorite_offers",
          fav: true,
          icon: "fa-star",
          id: "fav-icon",
          class: "highlight bold",
          ngClick: openCart
        },
        {
          label: "nav.change_lang",
          class: "lang",
          ngClick: i18nService.switchLang
        }
      ]
    });


    var $sideNavBackDrop;
    //side menu
    $scope.$on('$viewContentAnimationEnded', function (event)
    {

      var sideNav = $('.side-menu');
      $('.open-menu').on('click', function ()
      {
        $sideNavBackDrop =
          $('<div class="modal-backdrop" style="z-index:1001;    display: none;    background-color: #000b;"></div>')
            .appendTo("body").fadeIn(400)
            .on('click', hideSideMenu);

        sideNav.addClass('show-side-menu');
        sideNav.find(" a ").click(hideSideMenu)
      });
      $('.close-menu').on('click', hideSideMenu);

      function hideSideMenu()
      {
        sideNav.removeClass('show-side-menu');
        $sideNavBackDrop.fadeOut(400, function ()
        {
          $(this).remove();
        });
      }

      var sideMenu = document.getElementById('side-menu');
      window.onclick = function (event)
      {
        if (event.target === sideMenu)
        {
          sideNav.removeClass('show-side-menu');
        }
      };
      $(window).on('resize', function ()
      {
        if ((window.innerWidth > 760) && sideNav.hasClass('show-side-menu'))
        {
          sideNav.removeClass('show-side-menu');
        }
      });
    });

    // Data


    // Methods

    function openCart()
    {
      $("#favorite-modal").modal("show");
    }

    //////////
  }
})();


(function ()
{
  'use strict';

  angular
    .module('dbs.footer', [])
    .config(config);

  /** @ngInject */
  function config()
  {
  }
})();


(function ()
{
  'use strict';

  angular
    .module('dbs.footer')
    .controller('FooterController', FooterController);

  /** @ngInject */
  function FooterController($scope)
  {
    var vm = this;
    // Data

    // Methods

    //////////
  }
})();


(function ()
{
  'use strict';

  angular
    .module('dbs', [

      // Core
      'okoone.core',

      // dbs
      'dbs.header',
      'dbs.footer',

      'dbs.home',
      'dbs.offer',
      'slickCarousel',
      'ui.carousel',
      'dibari.angular-ellipsis',
      'duScroll'

    ]);
})();

(function ()
{
  'use strict';

  angular
    .module('dbs')
    .factory('favoriteService', favoriteService);


  /** @ngInject */
  function favoriteService($rootScope, localStorageService)
  {
    var favoriteCodes = localStorageService.get('favoriteCodes') || [];
    var redeemedCodes = localStorageService.get('redeemedCodes') || [];
    var visitedCodes = localStorageService.get('visitedCodes') || [];

    $rootScope.favorites = {
      all: loadFavoriteDatafromCodes(favoriteCodes),
      add: add,
      remove: remove,
      redeemed: {
        all: loadRedeemedDatafromCodes(redeemedCodes),
        add: addRedeemed
      },
      visited: {
        all: loadVisitedDatafromCodes(visitedCodes),
        add: addVisited
      }
    };
    return $rootScope.favorites;


    function add(offerCode)
    {
      var fav = $rootScope.favorites.all.find(function (x)
      {
        return x.code === offerCode;
      });

      if (fav)
      {
        return;
        //already in favorites
      }
      favoriteCodes.push(offerCode);
      localStorageService.set('favoriteCodes', favoriteCodes);
      $rootScope.favorites.all.push($rootScope._data.offers.find(function (o)
      {
        return o.code === offerCode
      }));
      $('#fav-icon, .open-menu').removeClass('tada animated').addClass('tada animated')
        .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function ()
        {
          $(this).removeClass('tada animated');
        });
    }

    function remove(offerCode)
    {
      var index = favoriteCodes.indexOf(offerCode);
      if (index !== -1)
      {
        favoriteCodes.splice(index, 1);
        $rootScope.favorites.all.splice(index, 1);
        localStorageService.set('favoriteCodes', favoriteCodes);
      }
    }

    function loadFavoriteDatafromCodes(favoriteCodes)
    {
      return favoriteCodes.map(function (f)
      {
        return $rootScope._data.offers.find(function (o)
        {
          return f === o.code;
        })
      }).filter(function (x)
      {
        return x
      });
    }



    function addRedeemed(offerCode)
    {
      var red = $rootScope.favorites.redeemed.all.find(function (x)
      {
        return x.code === offerCode;
      });

      if (red)
      {
        return;
        //already in redeemed
      }
      redeemedCodes.push(offerCode);
      localStorageService.set('redeemedCodes', redeemedCodes);
      $rootScope.favorites.redeemed.all.push($rootScope._data.offers.find(function (o)
      {
        return o.code === offerCode
      }));
    }

    function loadRedeemedDatafromCodes(redeemedCodes)
    {
      return redeemedCodes.map(function (f)
      {
        return $rootScope._data.offers.find(function (o)
        {
          return f === o.code;
        })
      }).filter(function (x)
      {
        return x
      });
    }


    function addVisited(offerCode)
    {
      var red = $rootScope.favorites.visited.all.find(function (x)
      {
        return x.code === offerCode;
      });

      if (red)
      {
        return;
        //already in visited
      }
      visitedCodes.push(offerCode);
      localStorageService.set('visitedCodes', visitedCodes);
      $rootScope.favorites.visited.all.push($rootScope._data.offers.find(function (o)
      {
        return o.code === offerCode
      }));
    }

    function loadVisitedDatafromCodes(visitedCodes)
    {
      return visitedCodes.map(function (f)
      {
        return $rootScope._data.offers.find(function (o)
        {
          return f === o.code;
        })
      }).filter(function (x)
      {
        return x
      });
    }
  }
}());

(function ()
{
  'use strict';

  angular
    .module('dbs.offer')
    .controller('FavoriteModalController', FavoriteModalController);

  /** @ngInject */
  function FavoriteModalController($scope, favoriteService)
  {
    var fm = this;
    fm.favoriteOffers = favoriteService.all;
    fm.removeFavorite = removeFavorite;
    // $scope.$watch('fm.favoriteOffers', function (current, old)
    // {
    //   if (angular.isUndefined(current) || angular.equals(current, old))
    //   {
    //     return;
    //   }
    //
    // },true);

    // Methods

    function removeFavorite(offerCode, $event)
    {

      $($event.target).parents(".offer-card-wrapper").fadeOut(1000, function ()
      {
        $scope.$apply(function ()
        {
          favoriteService.remove(offerCode);

        })
      });
    }
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .factory('msUtils', msUtils);

  /** @ngInject */
  function msUtils($window)
  {
    // Private variables
    var mobileDetect = new MobileDetect($window.navigator.userAgent),
      browserInfo = null;

    var service = {
      exists: exists,
      detectBrowser: detectBrowser,
      guidGenerator: guidGenerator,
      isMobile: isMobile,
      toggleInArray: toggleInArray
    };

    return service;

    //////////

    /**
     * Check if item exists in a list
     *
     * @param item
     * @param list
     * @returns {boolean}
     */
    function exists(item, list)
    {
      return list.indexOf(item) > -1;
    }

    /**
     * Returns browser information
     * from user agent data
     *
     * Found at http://www.quirksmode.org/js/detect.html
     * but modified and updated to fit for our needs
     */
    function detectBrowser()
    {
      // If we already tested, do not test again
      if (browserInfo)
      {
        return browserInfo;
      }

      var browserData = [
        {
          string: $window.navigator.userAgent,
          subString: 'Edge',
          versionSearch: 'Edge',
          identity: 'Edge'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Chrome',
          identity: 'Chrome'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'OmniWeb',
          versionSearch: 'OmniWeb/',
          identity: 'OmniWeb'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Apple',
          versionSearch: 'Version',
          identity: 'Safari'
        },
        {
          prop: $window.opera,
          identity: 'Opera'
        },
        {
          string: $window.navigator.vendor,
          subString: 'iCab',
          identity: 'iCab'
        },
        {
          string: $window.navigator.vendor,
          subString: 'KDE',
          identity: 'Konqueror'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Firefox',
          identity: 'Firefox'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Camino',
          identity: 'Camino'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Netscape',
          identity: 'Netscape'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'MSIE',
          identity: 'Explorer',
          versionSearch: 'MSIE'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Trident/7',
          identity: 'Explorer',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Gecko',
          identity: 'Mozilla',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Mozilla',
          identity: 'Netscape',
          versionSearch: 'Mozilla'
        }
      ];

      var osData = [
        {
          string: $window.navigator.platform,
          subString: 'Win',
          identity: 'Windows'
        },
        {
          string: $window.navigator.platform,
          subString: 'Mac',
          identity: 'Mac'
        },
        {
          string: $window.navigator.platform,
          subString: 'Linux',
          identity: 'Linux'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPhone',
          identity: 'iPhone'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPod',
          identity: 'iPod'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPad',
          identity: 'iPad'
        },
        {
          string: $window.navigator.platform,
          subString: 'Android',
          identity: 'Android'
        }
      ];

      var versionSearchString = '';

      function searchString(data)
      {
        for (var i = 0; i < data.length; i++)
        {
          var dataString = data[i].string;
          var dataProp = data[i].prop;

          versionSearchString = data[i].versionSearch || data[i].identity;

          if (dataString)
          {
            if (dataString.indexOf(data[i].subString) !== -1)
            {
              return data[i].identity;

            }
          }
          else if (dataProp)
          {
            return data[i].identity;
          }
        }
      }

      function searchVersion(dataString)
      {
        var index = dataString.indexOf(versionSearchString);

        if (index === -1)
        {
          return;
        }

        return parseInt(dataString.substring(index + versionSearchString.length + 1));
      }

      var browser = searchString(browserData) || 'unknown-browser';
      var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) ||
        'unknown-version';
      var os = searchString(osData) || 'unknown-os';

      // Prepare and store the object
      browser = browser.toLowerCase();
      version = browser + '-' + version;
      os = os.toLowerCase();

      browserInfo = {
        browser: browser,
        version: version,
        os: os
      };

      return browserInfo;
    }

    /**
     * Generates a globally unique id
     *
     * @returns {*}
     */
    function guidGenerator()
    {
      var S4 = function ()
      {
        return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
      };
      return (S4() + S4() + S4() + S4() + S4() + S4());
    }

    /**
     * Return if current device is a
     * mobile device or not
     */
    function isMobile()
    {
      return mobileDetect.mobile();
    }

    /**
     * Toggle in array (push or splice)
     *
     * @param item
     * @param array
     */
    function toggleInArray(item, array)
    {
      if (array.indexOf(item) === -1)
      {
        array.push(item);
      }
      else
      {
        array.splice(array.indexOf(item), 1);
      }
    }
  }
}());

(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .value('i18nLangList', {
      'en': {
        lang: 'en',
        locale: 'en-gb'
      },
      'zh': {
        lang: 'zh',
        locale: 'zh-cn'
      }
    })
    .value('i18nDefaultLang', 'en')
    .factory('i18nService', i18nService);

  /** @ngInject */
  function i18nService($rootScope, $state, $translate, i18nLangList, i18nDefaultLang)
  {

    var service = {
      switchLang: switchLang,
      getTrans: getTrans
    };

    return service;

    //////////
    function switchLang()
    {
      $("body").removeClass($rootScope.lang)
      $rootScope.lang = $rootScope.lang === 'en' ? 'zh' : 'en';
      moment.locale(i18nLangList[$rootScope.lang].locale);
      $translate.use(i18nLangList[$rootScope.lang].lang);
      $("body").addClass($rootScope.lang)

    }

    function getTrans(translationId, languageCode)
    {
      var translations = $translate.getTranslationTable($rootScope.lang);

      if(languageCode){
        translations = $translate.getTranslationTable(languageCode);
        return translations[translationId];;
      }

      if (translations && translations[translationId])
      {
        return translations[translationId];
      }
      //fallback to default langage
      translations = $translate.getTranslationTable(i18nDefaultLang);
      if (translations)
      {
        return translations[translationId];
      }
    }
  }
}());

(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .run(dataLoader);

  /**
   * Load data and translation into $rootscope for easy access
   *
   * @param $rootScope
   * @return {{offers: Array, categorys: Array, merchants: Array}}
   */
  /** @ngInject */
  function dataLoader($rootScope)
  {
    var _data = {
      offers: [],
      trendings: [],
      categorys: [],
      merchants: [],
      sliders: []
    };

    loadDatas();
    loadTrendings();
    loadTranslations();

    $rootScope._data = _data;
    // console.log(_data);
    return _data;

    function loadDatas()
    {
      for (var objType in data.data)
      {
        _data[objType] = data.data[objType];

        for (var i in _data[objType])
        {
          var obj = _data[objType][i];
          for (var ptyName in obj)
          {

            if (ptyName.indexOf("Code") === -1)
            {
              // simple pty
              continue;
            }
            var ptyVal = obj[ptyName];
            var splittedPtyName = ptyName.split("Code"),
              isMany = splittedPtyName[1] === "s";

            ptyName = splittedPtyName[0];
            var linkedObj;
            if (isMany)
            {
              // array of obj
              for (var j in ptyVal)
              {
                linkedObj = getDataObj(ptyName, ptyVal[j]);
                if (!obj[ptyName + "s"])
                {
                  obj[ptyName + "s"] = [];
                }
                obj[ptyName + "s"].push(linkedObj);
              }
            }
            else
            {
              //simple object
              linkedObj = getDataObj(ptyName, ptyVal);
              obj[ptyName] = linkedObj;
            }
          }
        }
      }
    }

    function loadTrendings()
    {
      _data.trendings = data.data.trendings.map(function (x)
      {
        return _data.offers.find(function (y)
        {
          return x === y.code
        })
      });
    }


    function loadTranslations()
    {
      for (var langCode in data.trans)
      {
        for (var objType in data.trans[langCode])
        {
          if (objType === 'website')
          {
            continue;
          } // website translations are loaded by index.config
          for (var objCode in data.trans[langCode][objType])
          {
            for (var ptyName in data.trans[langCode][objType][objCode])
            {
              var trans = data.trans[langCode][objType][objCode][ptyName];
              var obj = getObjByCode(objType, objCode);
              if (!obj)
              {
                console.log(
                  objType + " '" + objCode + "' doesn't exist but have a translation in 'data/translations/data-" +
                  langCode + ".js'");
              }
              else
              {

                if (!obj[ptyName])
                {
                  obj[ptyName] = {};
                }
                var objTypeKey = objType.endsWith("s") ? objType : objType + "s";
                obj[ptyName] = objTypeKey + "." + objCode + "." + ptyName;
              }
            }
          }
        }
      }
    }

    function getDataObj(ptyName, ptyVal)
    {
      // obj
      switch (ptyName)
      {
        case "merchant":
        case "category":
          //deduplicate
          var obj = getObjByCode(ptyName, ptyVal);
          if (obj)
          {//obj found
            return obj;
          }
          else
          {//obj not found
            obj = {
              code: ptyVal
            };
            _data[ptyName + "s"].push(obj);
            return obj;
          }
      }
    }

    function getObjByCode(objType, code)
    {
      if (!objType.endsWith("s"))
      {
        objType += "s";
      }
      var objs = _data[objType].filter(function (o)
      {
        return o.code === code;
      });
      if (objs.length > 1)
      {
        throw new Error("More than one '" + objType + "' found for code '" + code + "'");
      }
      return objs[0];
    }
  }
}());

'use strict';

(function (angular)
{
  // Create all modules and define dependencies to make sure they exist
  // and are loaded in the correct order to satisfy dependency injection
  // before all nested files are concatenated by Gulp

  // Config
  angular.module('ui.carousel.config', []).value('ui.carousel.config', {
    debug: true
  });

  // Modules
  angular.module('ui.carousel.providers', []);
  angular.module('ui.carousel.controllers', []);
  angular.module('ui.carousel.directives', []);
  angular.module('ui.carousel',
    ['ui.carousel.config', 'ui.carousel.directives', 'ui.carousel.controllers', 'ui.carousel.providers']);
})(angular);
'use strict';

/**
 * angular-ui-carousel
 * for example:
 * length = 8, show = 4, scroll = 3, current = 0
 *          ---------
 *          |       |
 *  |4|5|6|7|0|1|2|3|4|5|6|7|1|2|3|4
 *          |       |
 *          ---------
 * rectangle is visible for users
 */
angular.module('ui.carousel.controllers').controller('CarouselController',
  ['$scope', '$element', '$timeout', '$q', 'Carousel', '$window',
    function ($scope, $element, $timeout, $q, Carousel, $window)
    {
      var _this = this;

      /**
       * Initial carousel
       *
       * Mirgate to angularjs 1.6
       * @see https://docs.angularjs.org/guide/migration#commit-bcd0d4
       */
      this.$onInit = function ()
      {
        _this.initOptions();
        _this.initRanges();
        _this.setProps();
        _this.setupInfinite();
      };

      /**
       * Init option based on directive config
       */
      this.initOptions = function ()
      {
        _this.options = angular.extend({}, Carousel.getOptions());

        // TODO customize attribute from directive
        if (_this.initialSlide !== undefined)
        {
          _this.options.initialSlide = _this.initialSlide;
        }
        if (_this.fade !== undefined)
        {
          _this.options.fade = _this.fade;
        }
        if (_this.autoplay !== undefined)
        {
          _this.options.autoplay = _this.autoplay;
        }
        if (_this.autoplaySpeed !== undefined)
        {
          _this.options.autoplaySpeed = _this.autoplaySpeed;
        }
        if (_this.cssEase !== undefined)
        {
          _this.options.cssEase = _this.cssEase;
        }
        if (_this.touchCssEase !== undefined)
        {
          _this.options.touchCssEase = _this.touchCssEase;
        }
        if (_this.speed !== undefined)
        {
          _this.options.speed = _this.speed;
        }
        if (_this.infinite !== undefined)
        {
          _this.options.infinite = _this.infinite;
        }
        if (_this.arrows !== undefined)
        {
          _this.options.arrows = _this.arrows;
        }
        if (_this.dots !== undefined)
        {
          _this.options.dots = _this.dots;
        }
        if (_this.visiblePrev !== undefined)
        {
          _this.options.visiblePrev = _this.visiblePrev;
        }
        if (_this.visibleNext !== undefined)
        {
          _this.options.visibleNext = _this.visibleNext;
        }

        // TODO write more options for fade mode
        // In fade mode we have to setting slides-to-show and slides-to-scroll
        // to 1 slide
        if (_this.options.fade)
        {
          _this.options.slidesToShow = 1;
          _this.options.slidesToScroll = 1;
        } else
        {
          if (_this.show)
          {
            _this.options.slidesToShow = _this.show;
          }
          if (_this.scroll)
          {
            _this.options.slidesToScroll = _this.scroll;
          }
        }
      };

      /**
       * init variables, slides, ..
       */
      this.initRanges = function ()
      {
        if (!_this.slides)
        {
          _this.slides = [];
        }

        _this.isCarouselReady = false;
        _this.isTrackMoving = false;
        _this.track = $element.find('.track');
        _this.width = 1; // Fake width
        _this.currentSlide = _this.options.initialSlide;
        _this.trackStyle = {};
        _this.slideStyle = {};

        _this.isVisibleDots = false;
        _this.isVisiblePrev = _this.options.visiblePrev;
        _this.isVisibleNext = _this.options.visibleNext;

        _this.isClickablePrev = false;
        _this.isClickableNext = false;

        _this.animType = null;
        _this.transformType = null;
        _this.transitionType = null;
        _this.shouldClick = true;
      };

      /**
       * Init UI and carousel track
       */
      this.initUI = function ()
      {
        _this.width = $element[0].clientWidth;

        // Update track width first
        _this.initTrack();
        _this.setupTouchMove();

        // Then item style
        $timeout(function ()
        {
          _this.updateItemStyle();
        }, 200);
      };

      /**
       * update common style for each carousel item
       */
      this.updateItemStyle = function ()
      {
        _this.itemWidth = _this.width / _this.options.slidesToShow;
        _this.slideStyle = {
          'width': _this.itemWidth + 'px'
        };
      };

      /**
       * init carousel track
       * also make Carousel is Ready
       */
      this.initTrack = function ()
      {
        var itemWidth = _this.width / _this.options.slidesToShow;
        var trackWidth = itemWidth * _this.slidesInTrack.length;

        _this.trackStyle.width = trackWidth + 'px';

        _this.slideHandler(_this.currentSlide).finally(function ()
        {
          _this.isCarouselReady = true;

          if (!_this.options.fade)
          {
            _this.refreshTrackStyle();
          }

          // onInit callback
          if (_this.onInit)
          {
            _this.onInit();
          }
        }).catch(function ()
        {
          // Catch err
        });
      };

      /**
       * @see https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L680
       *
       * Sync slide to place it should be
       * for example:
       * - 9 total, 3 show, 3 scroll, current 1
       *   => next index = 3 (previous index counted = 0)
       *
       * and scroll to next page:
       * - 6 total, 1 show, 1 scroll, current 0 => next index = 1
       * - 9 total, 3 show, 3 scroll, current 1 => next index = 3
       * - 9 total, 3 show, 3 scroll, current 3 => next index = 6
       * - 9 total, 3 show, 3 scroll, current 8 => next index = 3
       * - 8 total, 4 show, 3 scroll, current 1 => next index = 4
       */
      this.next = function ()
      {
        if (!_this.isClickableNext)
        {
          return false;
        }

        var indexOffset = _this.getIndexOffset();
        var slideOffset = indexOffset === 0 ? _this.options.slidesToScroll : indexOffset;

        _this.slideHandler(_this.currentSlide + slideOffset).catch(function ()
        {
          // Catch err
        });
      };

      /**
       * move to previous slide
       * same calculate with next
       * @see next function
       */
      this.prev = function ()
      {
        if (!_this.isClickablePrev)
        {
          return false;
        }

        var indexOffset = _this.getIndexOffset();
        var slideOffset = indexOffset === 0 ? _this.options.slidesToScroll : _this.options.slidesToShow - indexOffset;

        _this.slideHandler(_this.currentSlide - slideOffset).catch(function ()
        {
          // Catch err
        });
      };

      /**
       * Get index offset
       */
      this.getIndexOffset = function ()
      {
        var scrollOffset = _this.slides.length % _this.options.slidesToScroll !== 0;
        var indexOffset = scrollOffset ? 0 : (_this.slides.length - _this.currentSlide) % _this.options.slidesToScroll;

        return indexOffset;
      };

      /**
       * move to page
       * @params int page
       * Page counter from 0 (start = 0)
       */
      this.movePage = function (page)
      {
        var target = _this.options.slidesToScroll * page;
        _this.slideHandler(target).catch(function ()
        {
          // Catch err
        });
      };

      /**
       * hanlder carousel
       * @description move carousel to correct page
       *
       * @params int index
       */
      this.slideHandler = function (index)
      {
        // TODO prevent when slides not exists
        if (!_this.slides)
        {
          return $q.reject('Carousel not fully setup');
        }

        // TODO Prevent when track is moving
        if (_this.isTrackMoving && _this.dragging)
        {
          return $q.reject('Track is moving "' + _this.isTrackMoving + '" or dragging"' + _this.dragging + '"');
        }
        // console.log("slideHandler" + index);

        var len = _this.slides.length;
        var show = _this.options.slidesToShow;

        if (len <= show)
        {
          _this.correctTrack();
          return $q.reject('Length of slides smaller than slides to show');
        }

        // We need target to destination
        // and a anim slide to translate track
        //
        // anim = animSlide (which we use to move)
        // target = targetSlide
        var anim = index;
        var target = null;

        if (anim < 0)
        {
          if (len % _this.options.slidesToScroll !== 0)
          {
            target = len - len % _this.options.slidesToScroll;
          } else
          {
            target = len + anim;
          }
        } else if (anim >= len)
        {
          if (len % _this.options.slidesToScroll !== 0)
          {
            target = 0;
          } else
          {
            target = anim - len;
          }
        } else
        {
          target = anim;
        }

        if (_this.onBeforeChange)
        {
          // @see https://docs.angularjs.org/guide/directive
          _this.onBeforeChange({currentSlide: _this.currentSlide, target: target});
        }

        // Fade handler
        if (_this.options.fade)
        {
          _this.currentSlide = target;

          // XXX
          // afterChange method
          // fire after faded
          // Should be revised
          $timeout(function ()
          {
            _this.autoplayTrack();

            if (_this.onAfterChange)
            {
              _this.onAfterChange({currentSlide: _this.currentSlide});
            }
          }, _this.options.speed);
          return $q.when('Handler fade');
        }

        // No-fade handler
        var itemWidth = _this.width / _this.options.slidesToShow;
        var left = -1 * target * itemWidth;
        if (_this.options.infinite)
        {
          left = -1 * (anim + show) * itemWidth;
        }

        _this.isTrackMoving = true;
        return _this.moveTrack(left).then(function ()
        {
          // console.log("moveTrack finished");
          _this.isTrackMoving = false;
          _this.currentSlide = target;
          _this.touchObject = {};

          _this.autoplayTrack();

          if (target !== anim)
          {
            _this.correctTrack();
          }

          if (!_this.options.infinite)
          {
            if (_this.currentSlide === 0)
            {
              _this.isClickablePrev = false;
              _this.isClickableNext = true;
            } else if (_this.currentSlide === _this.slidesInTrack.length - _this.options.slidesToShow)
            {
              _this.isClickableNext = false;
              _this.isClickablePrev = true;
            } else
            {
              _this.isClickablePrev = true;
              _this.isClickableNext = true;
            }
          }

          // XXX
          // afterChange method
          // fire after 200ms wakeup and correct track
          // Should be revised
          $timeout(function ()
          {
            if (_this.onAfterChange)
            {
              _this.onAfterChange({currentSlide: _this.currentSlide});
            }
          }, 200);
        });
      };

      /**
       * moveTrack
       * move track to left position using css3 translate
       * for example left: -1000px
       */
      this.moveTrack = function (left)
      {
        var deferred = $q.defer();
        // console.log("moveTrack :" + left);
        if (_this.options.vertical === false)
        {
          _this.trackStyle[_this.animType] = 'translate3d(' + left + 'px, 0px, 0px)';
        } else
        {
          _this.trackStyle[_this.animType] = 'translate3d(0px, ' + left + 'px, 0px)';
        }


        $timeout(function ()
        {
          deferred.resolve('Track moved');
        }, _this.options.speed);

        return deferred.promise;
      };

      /**
       * correctTrack
       * @description correct track after move to animSlide we have to move track
       * to exactly its position
       */
      this.correctTrack = function ()
      {
        if (_this.options.infinite)
        {
          (function ()
          {
            var left = 0;
            if (_this.slides.length > _this.options.slidesToShow)
            {
              left = -1 * (_this.currentSlide + _this.options.slidesToShow) * _this.itemWidth;
            }

            // Move without anim
            _this.trackStyle[_this.transitionType] = _this.transformType + ' ' + 0 + 'ms ' + _this.options.cssEase;

            _this.isTrackMoving = true;
            $timeout(function ()
            {
              _this.trackStyle[_this.animType] = 'translate3d(' + left + 'px, 0, 0px)';

              // Revert animation
              $timeout(function ()
              {
                _this.refreshTrackStyle();
                _this.isTrackMoving = false;
              }, 200);
            });
          })();
        }
      };

      /**
       * Refresh track style
       */
      this.refreshTrackStyle = function ()
      {
        _this.trackStyle[_this.transitionType] = _this.transformType + ' ' +
          (_this.dragging ? _this.options.touchSpeed : _this.options.speed ) + 'ms ' +
          ( _this.dragging ? _this.options.touchCssEase : _this.options.cssEase);
      };

      /**
       * autoplay track
       * @description autoplay = true
       */
      this.autoplayTrack = function ()
      {
        if (_this.options.autoplay)
        {
          if (_this.timeout)
          {
            $timeout.cancel(_this.timeout);
          }

          _this.timeout = $timeout(function ()
          {
            _this.next();

            $timeout.cancel(_this.timeout);
            _this.timeout = null;
          }, _this.options.autoplaySpeed);
        }
      };

      this.getSlideStyle = function (index)
      {
        var style = _this.slideStyle;
        if (_this.options.fade)
        {
          var left = -1 * index * _this.itemWidth;
          var uniqueStyle = {
            position: 'relative',
            top: '0px',
            left: left + 'px',
            'z-index': index === _this.currentSlide ? 10 : 9,
            opacity: index === _this.currentSlide ? 1 : 0
          };

          if (index >= _this.currentSlide - 1 && index <= _this.currentSlide + 1)
          {
            uniqueStyle.transition = 'opacity 250ms linear';
          }

          style = angular.extend(style, uniqueStyle);
        }

        return style;
      };

      /**
       * setupInfinite
       * To make carouse infinite we need close number of slidesToShow elements to
       * previous elements and to after elements
       *
       * length = 8, show = 4, scroll = 3, current = 0
       *          ---------
       *          |       |
       *  |4|5|6|7|0|1|2|3|4|5|6|7|1|2|3|4
       *          |       |
       *          ---------
       */
      this.setupInfinite = function ()
      {
        // Clone
        var len = _this.slides.length;
        var show = _this.options.slidesToShow;

        var tmpTrack = angular.copy(_this.slides);

        if (_this.options.infinite && _this.options.fade === false)
        {
          if (len > show)
          {
            var number = show;
            for (var i = 0; i < number; i++)
            {
              tmpTrack.push(angular.copy(_this.slides[i]));
            }
            for (var _i = len - 1; _i >= len - show; _i--)
            {
              tmpTrack.unshift(angular.copy(_this.slides[_i]));
            }
          }
        }

        _this.slidesInTrack = tmpTrack;
      };


      /********************* touch event support ***********************/

      this.setupTouchMove = function ()
      {
        var _ = _this;
        _.$slider = $(".track-wrapper");
        _.$slider.off("click touchstart touchmove touchend touchcancel mousedown mousemove mouseup mouseleave");
        _.$slider.on('click', {action: 'click'}, _.clickHandler);
        _.$slider.on('touchstart mousedown', {action: 'start'}, _.swipeHandler);
        _.$slider.on('touchmove mousemove', {action: 'move'}, _.swipeHandler);
        _.$slider.on('touchend mouseup', {action: 'end'}, _.swipeHandler);
        _.$slider.on('touchcancel mouseleave', {action: 'end'}, _.swipeHandler);
        if (!_.touchObject)
        {
          _.touchObject = {};
        }

      };

      this.clickHandler = function (event)
      {

        var _ = _this;
        // console.warn("click");

        if (!_.shouldClick)
        {
          // console.warn("click stop");
          event.stopImmediatePropagation();
          event.stopPropagation();
          event.preventDefault();
        }

      };

      this.swipeHandler = function (event)
      {

        var _ = _this;
        _.listWidth = $(".track-wrapper").width();
        _this.touchObject.minSwipe = _.$slider.find(".offer-card").first().width() / 5;

        // if ('ontouchend' in document) {
        //   return;
        // } else
        if (_.options.draggable === false && event.type.indexOf('mouse') !== -1)
        {
          return;
        }


        _.touchObject.fingerCount =
          event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;


        // if (_.options.verticalSwiping === true) {
        //   _.touchObject.minSwipe = _.listHeight / _.options
        //       .touchThreshold;
        // }

        switch (event.data.action)
        {

          case 'start':
            _.swipeStart(event);
            break;

          case 'move':
            _.swipeMove(event);
            break;

          case 'end':
            _.swipeEnd(event);
            break;
        }
      };


      this.swipeStart = function (event)
      {
        console.warn("swipeHandler swipeStart1");

        var _ = _this,
          touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow || _this.isTrackMoving)
        {
          console.warn("swipeHandler swipeStart reset toucheobject", _.touchObject);
          _.touchObject = {};
          return false;
        }
        console.warn("swipeHandler swipeStart2");

        if (_this.dragging)
        {
          console.warn("swipeHandler swipeStart dragging", _.touchObject);
          return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined)
        {
          touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
        console.warn("swipeHandler swipeStart", _.touchObject);

        _.dragging = true;

      };

      this.swipeMove = function (event)
      {
        var _ = _this,
          edgeWasHit = false,
          curLeft, swipeDirection, swipeLength, positionOffset, touches;
        // console.warn("swipeHandler swipeMove", _.touchObject);

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || touches && touches.length !== 1 || !_.interrupted)
        {
          return false;
        }

        var curLeft = 0;
        if (_this.slides.length > _this.options.slidesToShow)
        {
          curLeft = -1 * (_this.currentSlide + _this.options.slidesToShow) * _this.itemWidth;
        }

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
          Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        if (_.options.verticalSwiping === true)
        {
          _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        }

        swipeDirection = _.swipeDirection();
        // console.log("swipeDirection = " + swipeDirection);

        if (swipeDirection === 'vertical')
        {
          return;
        }

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4)
        {
          event.preventDefault();
        }

        positionOffset = /*(_.options.rtl === false ? 1 : -1) * */(_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true)
        {
          positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false)
        {
          if ((_.currentSlide === 0 && swipeDirection === 'right') ||
            (_.currentSlide >= _.getDotCount() && swipeDirection === 'left'))
          {
            swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
            _.touchObject.edgeHit = true;
          }
        }

        if (_.options.vertical === false)
        {
          _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else
        {
          _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true)
        {
          _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false)
        {
          return false;
        }

        if (_.animating === true)
        {
          _.swipeLeft = null;
          return false;
        }

        // Move without anim
        _this.trackStyle[_this.transitionType] = _this.transformType + ' ' + 0 + 'ms ' + _this.options.cssEase;

        _this.isTrackMoving = true;
        $timeout(function ()
        {
          _this.trackStyle[_this.animType] = 'translate3d(' + _.swipeLeft + 'px, 0, 0px)';

          // // Revert animation
          // $timeout(function () {
          //   _this.refreshTrackStyle();
          //   _this.isTrackMoving = false;
          // }, 200);
        });


      };

      this.swipeEnd = function (event)
      {
        // console.warn("swipeHandler swipeEnd");

        var _ = this,
          slideCount,
          direction;

        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength <= 10;

        // _this.isTrackMoving = false;
        _this.refreshTrackStyle();

        if (_.touchObject.curX === undefined)
        {
          return false;
        }

        if (_.touchObject.edgeHit === true)
        {
          _.$slider.trigger('edge', [_, _.swipeDirection()]);
        }

        if (_.touchObject.swipeLength >= _.touchObject.minSwipe)
        {

          direction = _.swipeDirection();

          switch (direction)
          {

            case 'left':
            case 'down':

              slideCount =
                _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + 1) : _.currentSlide + 1;

              _.currentDirection = 0;

              break;

            case 'right':
            case 'up':

              slideCount =
                _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - 1) : _.currentSlide - 1;

              _.currentDirection = 1;

              break;

            default:


          }

          if (direction != 'vertical')
          {
            $timeout(function ()
            {

              // console.log("swipe validated " + slideCount);
              _.dragging = false;
              _.slideHandler(slideCount);
              // _.$slider.trigger('swipe', [_, direction ]);

              // _this.trackStyle[_this.transitionType] = _this.transformType + ' ' + _this.options.speed + 'ms ' +
              // _this.options.cssEase;
            });
          }

        } else
        {

          if (_.touchObject.startX !== _.touchObject.curX)
          {
            $timeout(function ()
            {

              // console.log("swipe cancelled " + _.currentSlide);

              _.dragging = false;
              _.slideHandler(_.currentSlide);
            });

          } else
          {
            _.dragging = false;
            _this.isTrackMoving = false;
          }

        }

      };


      this.swipeDirection = function ()
      {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0)
        {
          swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0))
        {
          return 'left'
          // return  (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315))
        {
          return 'left'
          // return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225))
        {
          return 'right'
          // return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true)
        {
          if ((swipeAngle >= 35) && (swipeAngle <= 135))
          {
            return 'down';
          } else
          {
            return 'up';
          }
        }

        return 'vertical';

      };


      this.getSlideCount = function ()
      {
        return _this.slidesInTrack.length;
      }


      /**
       * get number of dosts
       *
       * @return Array
       */
      this.getDots = function ()
      {
        if (!_this.slides)
        {
          return [];
        }

        var dots = Math.ceil(_this.slides.length / _this.options.slidesToScroll);

        var res = [];
        for (var i = 0; i < dots; i++)
        {
          res.push(i);
        }
        return res;
      };

      /**
       * set carousel property
       *
       * - animType
       * - transformType
       * - transitionType
       */
      this.setProps = function ()
      {
        var bodyStyle = document.body.style;

        /* eslint-disable */
        if (bodyStyle.OTransform !== undefined)
        {
          _this.animType = 'OTransform';
          _this.transformType = '-o-transform';
          _this.transitionType = 'OTransition';
        }
        if (bodyStyle.MozTransform !== undefined)
        {
          _this.animType = 'MozTransform';
          _this.transformType = '-moz-transform';
          _this.transitionType = 'MozTransition';
        }
        if (bodyStyle.webkitTransform !== undefined)
        {
          _this.animType = 'webkitTransform';
          _this.transformType = '-webkit-transform';
          _this.transitionType = 'webkitTransition';
        }
        if (bodyStyle.msTransform !== undefined)
        {
          _this.animType = 'msTransform';
          _this.transformType = '-ms-transform';
          _this.transitionType = 'msTransition';
        }
        if (bodyStyle.transform !== undefined && _this.animType !== false)
        {
          _this.animType = 'transform';
          _this.transformType = 'transform';
          _this.transitionType = 'transition';
        }
        /* eslint-enable */

        _this.transformsEnabled = true;
      };

      /**
       * Refresh carousel
       */
      this.refreshCarousel = function ()
      {
        if (_this.slides && _this.slides.length && _this.slides.length > _this.options.slidesToShow)
        {
          _this.isVisibleDots = true;
          _this.isVisiblePrev = true;
          _this.isVisibleNext = true;
          _this.isClickablePrev = true;
          _this.isClickableNext = true;
        } else
        {
          _this.isVisibleDots = false;
          _this.isVisiblePrev = _this.options.visiblePrev || false;
          _this.isVisibleNext = _this.options.visibleNext || false;
          _this.isClickablePrev = false;
          _this.isClickableNext = false;
        }

        // Re-init UI
        _this.initUI();
      };

      /**
       * refresh model
       */
      $scope.$watchCollection('ctrl.slides', function (slides)
      {
        if (!slides)
        {
          return;
        }

        // Init carousel
        if (_this.currentSlide > slides.length - 1)
        {
          _this.currentSlide = slides.length - 1;
        }

        _this.setupInfinite();
        _this.refreshCarousel();
      });

      /**
       * update when resize
       *
       * @see https://github.com/mihnsen/ui-carousel/issues/10
       * @author tarkant
       */
      angular.element($window).on('resize', this.refreshCarousel);

      /**
       * cleanup when done
       *
       * @see https://github.com/mihnsen/ui-carousel/issues/10
       * @author tarkant
       */
      $scope.$on('$destroy', function ()
      {
        angular.element($window).off('resize');
      });

      // Prior to v1.5, we need to call `$onInit()` manually.
      // (Bindings will always be pre-assigned in these versions.)
      if (angular.version.major === 1 && angular.version.minor < 5)
      {
        this.$onInit();
      }
    }]);
'use strict';

angular.module('ui.carousel.directives')
  .directive('uiCarousel', ['$compile', '$templateCache', '$sce', function ($compile, $templateCache, $sce)
  {

    return {
      restrict: 'AE',
      bindToController: true,
      scope: {
        name: '=?',
        slides: '=',
        show: '=?slidesToShow',
        scroll: '=?slidesToScroll',
        classes: '@',
        fade: '=?',
        onChange: '=?',
        disableArrow: '=?',
        autoplay: '=?',
        autoplaySpeed: '=?',
        cssEase: '=?',
        speed: '=?',
        infinite: '=?',
        arrows: '=?',
        dots: '=?',
        initialSlide: '=?',
        visibleNext: '=?',
        visiblePrev: '=?',

        // Method
        onBeforeChange: '&',
        onAfterChange: '&',
        onInit: '&'
      },
      link: function link($scope, el)
      {
        var template = angular.element($templateCache.get('ui-carousel/carousel.template.html'));

        // dynamic injections to override the inner layers' components
        var injectComponentMap = {
          'carousel-item': '.carousel-item',
          'carousel-prev': '.carousel-prev',
          'carousel-next': '.carousel-next'
        };

        var templateInstance = template.clone();
        angular.forEach(injectComponentMap, function (innerSelector, outerSelector)
        {
          var outerElement = el[0].querySelector(outerSelector);
          if (outerElement)
          {
            angular.element(templateInstance[0].querySelector(innerSelector)).html(outerElement.innerHTML);
          }
        });

        var compiledElement = $compile(templateInstance)($scope);
        el.addClass('ui-carousel').html('').append(compiledElement);
      },


      controller: 'CarouselController',
      controllerAs: 'ctrl'
    };
  }]);
'use strict';

angular.module('ui.carousel.providers').provider('Carousel', function ()
{
  var _this = this;

  this.options = {
    // Init like Slick carousel
    // XXX Should be revised
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    cssEase: 'ease',
    touchCssEase: 'ease',
    dots: false,

    easing: 'linear',
    fade: false,
    infinite: true,
    initialSlide: 0,

    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,

    visiblePrev: false,
    visibleNext: false,

    // Not available right now
    draggable: true,

    lazyLoad: 'ondemand',

    swipe: true,
    swipeToSlide: false,
    touchMove: true,

    vertical: false,
    verticalSwiping: false
  };
  this.$get = [function ()
  {
    return {
      setOptions: function setOptions(options)
      {
        _this.options = angular.extend(_this.options, options);
      },
      getOptions: function getOptions()
      {
        return _this.options;
      }
    };
  }];
});
'use strict';

(function (module)
{
  try
  {
    module = angular.module('ui.carousel');
  }
  catch (e)
  {
    module = angular.module('ui.carousel', []);
  }
  module.run(['$templateCache', function ($templateCache)
  {
    $templateCache.put('ui-carousel/carousel.template.html',
      '<div class="carousel-wrapper" ng-show="ctrl.isCarouselReady"><div class="track-wrapper"><div class="track" ng-style="ctrl.trackStyle"><div class="slide" ng-repeat="item in ctrl.slidesInTrack track by $index" ng-style="ctrl.getSlideStyle($index)"><div class="carousel-item"></div></div></div></div><div class="carousel-prev" ng-if="!ctrl.disableArrow" ng-show="ctrl.isVisiblePrev &amp;&amp; ctrl.options.arrows" ng-class="{\'carousel-disable\': !ctrl.isClickablePrev}" ng-click="ctrl.prev()"><button class="carousel-btn"><i class="ui-icon-prev"></i></button></div><div class="carousel-next" ng-if="!ctrl.disableArrow" ng-show="ctrl.isVisibleNext &amp;&amp; ctrl.options.arrows" ng-class="{\'carousel-disable\': !ctrl.isClickableNext}" ng-click="ctrl.next()"><button class="carousel-btn"><i class="ui-icon-next"></i></button></div><ul class="carousel-dots" ng-show="ctrl.isVisibleDots &amp;&amp; ctrl.options.dots"><li ng-repeat="dot in ctrl.getDots()" ng-class="{ \'carousel-active\': dot == ctrl.currentSlide/ctrl.options.slidesToScroll }" ng-click="ctrl.movePage(dot)"><button>{{ dot }}</button></li></ul></div>');
  }]);
})();

/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);

(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .directive('hljs', hljsDirective);

  /** @ngInject */
  function hljsDirective($timeout, $q, $interpolate)
  {
    return {
      restrict: 'E',
      compile: function (element, attr)
      {
        var code;
        //No attribute? code is the content
        if (!attr.code)
        {
          code = element.html();
          element.empty();
        }

        return function (scope, element, attr)
        {

          if (attr.code)
          {
            // Attribute? code is the evaluation
            code = scope.$eval(attr.code);
          }
          var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

          $q.when(code).then(function (code)
          {
            if (code)
            {
              if (shouldInterpolate)
              {
                code = $interpolate(code)(scope);
              }
              var contentParent = angular.element(
                '<pre><code class="highlight" ng-non-bindable></code></pre>'
              );
              element.append(contentParent);
              // Defer highlighting 1-frame to prevent GA interference...
              $timeout(function ()
              {
                render(code, contentParent);
              }, 34, false);
            }
          });

          function render(contents, parent)
          {

            var codeElement = parent.find('code');
            var lines = contents.split('\n');

            // Remove empty lines
            lines = lines.filter(function (line)
            {
              return line.trim().length;
            });

            // Make it so each line starts at 0 whitespace
            var firstLineWhitespace = lines[0].match(/^\s*/)[0];
            var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
            lines = lines.map(function (line)
            {
              return line
                .replace(startingWhitespaceRegex, '')
                .replace(/\s+$/, '');
            });

            var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
            highlightedCode.value = highlightedCode.value
              .replace(/=<span class="hljs-value">""<\/span>/gi, '')
              .replace('<head>', '')
              .replace('<head/>', '');
            codeElement.append(highlightedCode.value).addClass('highlight');
          }
        };
      }
    };
  }
})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .filter('toTrusted', toTrustedFilter)
    .filter('htmlToPlaintext', htmlToPlainTextFilter)
    .filter('nospace', nospaceFilter)
    .filter('humanizeDoc', humanizeDocFilter);

  /** @ngInject */
  function toTrustedFilter($sce)
  {
    return function (value)
    {
      return $sce.trustAsHtml(value);
    };
  }

  /** @ngInject */
  function htmlToPlainTextFilter()
  {
    return function (text)
    {
      return String(text).replace(/<[^>]+>/gm, '');
    };
  }

  /** @ngInject */
  function nospaceFilter()
  {
    return function (value)
    {
      return (!value) ? '' : value.replace(/ /g, '');
    };
  }

  /** @ngInject */
  function humanizeDocFilter()
  {
    return function (doc)
    {
      if (!doc)
      {
        return;
      }
      if (doc.type === 'directive')
      {
        return doc.name.replace(/([A-Z])/g, function ($1)
        {
          return '-' + $1.toLowerCase();
        });
      }
      return doc.label || doc.name;
    };
  }

})();

(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .filter('altDate', altDate)
    .filter('momentFormat', momentFormat);

  /** @ngInject */
  function momentFormat()
  {
    return function (value, format)
    {
      return moment(value).format(format);
    }
  }

  /** @ngInject */
  function altDate()
  {
    return function (value)
    {
      var diff = Date.now() - new Date(value);

      /**
       * If in a hour
       * e.g. "2 minutes ago"
       */
      if (diff < (60 * 60 * 1000))
      {
        return moment(value).fromNow();
      }
      /*
       * If in the day
       * e.g. "11:23"
       */
      else if (diff < (60 * 60 * 24 * 1000))
      {
        return moment(value).format('HH:mm');
      }
      /*
       * If in week
       * e.g "Tuesday"
       */
      else if (diff < (60 * 60 * 24 * 7 * 1000))
      {
        return moment(value).format('dddd');
      }
      /*
       * If more than a week
       * e.g. 03/29/2016
       */
      else
      {
        return moment(value).calendar();
      }

    };
  }

})();

(function ()
{
  'use strict';

  angular
    .module('dbs')
    .factory('recommendedService', recommendedService);


  /** @ngInject */
  function recommendedService($rootScope, favoriteService)
  {
    var offersKinds =
        {
          redeemed: {
            exclude: true,
            weight: 3,
            offers: favoriteService.redeemed.all
          },
          favorites: {
            weight: 2,
            offers: favoriteService.all
          },
          visited: {
            weight: 1,
            offers: favoriteService.visited.all
          }
        },
      debug = true;

    return {
      getAll: getAll
    };


    function getAll()
    {
      var allOffersWithWeight = getAllOffers();
      for (var offersKind in offersKinds)
      {
        var relatedOffers = [];
        for (var i in offersKinds[offersKind].offers)
        {
          var offer = offersKinds[offersKind].offers[i];
          // if(!offer)continue;

          relatedOffers.push(offer);
          relatedOffers =
            relatedOffers.concat(getSameCatOffers(allOffersWithWeight, offer),
              getSamePartnerOffers(allOffersWithWeight, offer));
        }

        for (var i in relatedOffers)
        {
          if (!relatedOffers[i]["score"])
          {
            relatedOffers[i]["score"] = 0;
          }
          relatedOffers[i]["score"] += offersKinds[offersKind].weight;
          if (debug)
          {
            console.log("adding " + offersKinds[offersKind].weight + " to offer " + relatedOffers[i].code);
          }
        }
      }
      if (debug)
      {
        console.log(allOffersWithWeight.sort(function (a, b)
        {
          return a.score >= b.score;
        }));
      }
      return allOffersWithWeight;
    }


    function getSamePartnerOffers(allOffers, offer)
    {
      var samePartnerOffers = allOffers.filter(function (x)
      {
        return x.code !== offer.code && x.merchantCode === offer.merchantCode;
      });
      if (debug)
      {
        console.log("Found " + samePartnerOffers.length + " offer with same partner than " + offer.code, offer,
          samePartnerOffers);
      }
      return samePartnerOffers;
    }


    function getSameCatOffers(allOffers, offer)
    {
      var sameCatOffers = [];
      for (var i in offer.categoryCodes)
      {
        sameCatOffers = sameCatOffers.concat(allOffers.filter(function (x)
        {
          return x.code !== offer.code && x.categoryCodes.indexOf(offer.categoryCodes[i]) !== -1;
        }));
      }
      if (debug)
      {
        console.log("Found " + sameCatOffers.length + " offer with same cat than " + offer.code, offer,
          sameCatOffers);
      }
      return sameCatOffers;
    }


    function getAllOffers()
    {
      return angular.copy($rootScope._data.offers);
    }
  }
}());


(function ()
{
  'use strict';

  angular
    .module('dbs')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $rootScope, $cookies)
  {
    // Data

    $scope.$on('$viewContentAnimationEnded', function (event)
    {
      // Remove the splash screen
      if (event.targetScope.$id === $scope.$id)
      {
        $rootScope.$broadcast('msSplashScreen::remove');
      }
    });
  }
})();

(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .run(runBlock)
    .run(anchorScroll);

  /** @ngInject */
  function runBlock(msUtils)
  {

    /**
     * Put isMobile() to the html as a class
     */
    if (msUtils.isMobile())
    {
      angular.element('html').addClass('is-mobile');
    }

    /**
     * Put browser information to the html as a class
     */
    var browserInfo = msUtils.detectBrowser();
    if (browserInfo)
    {
      var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
      angular.element('html').addClass(htmlClass);
    }
  }

  /** @ngInject */
  function anchorScroll($rootScope, $location, $state, $stateParams, $anchorScroll)
  {
    $rootScope.$on('$stateChangeSuccess', function ()
    {
      $("html, body").animate({scrollTop: 0}, 200);
    })
    $rootScope.$on('$routeChangeSuccess ', function ()
    {
      $("html, body").animate({scrollTop: 0}, 200);
    })
    //
    // $rootScope.$on('$stateChangeStart', function ()
    // {
    //   // set the location.hash to the id of
    //   // the element you wish to scroll to.
    //   $anchorScroll();
    //
    // });

  }


})();


(function ()
{
  'use strict';

  angular
    .module('okoone.core')
    .config(config);

  /** @ngInject */
  function config($ariaProvider, $logProvider, msScrollConfigProvider, $provide)
  {
    // Enable debug logging
    $logProvider.debugEnabled(true);

    /*eslint-disable */

    // ng-aria configuration
    $ariaProvider.config({
      tabindex: false
    });

    // msScroll configuration
    msScrollConfigProvider.config({
      wheelPropagation: true
    });

    $provide.decorator('$uiViewScroll', function ($delegate)
    {
      return function (uiViewElement)
      {
        // var top = uiViewElement.getBoundingClientRect().top;
        // window.scrollTo(0, (top - 30));
        // Or some other custom behaviour...
      };
    });

    /*eslint-enable */
  }
})();


(function ()
{
  'use strict';

  angular
    .module('dbs')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $timeout, $state)
  {

  
    // see what's going on when the route tries to change
    $rootScope.$on('$routeChangeStart', function (event, next, current)
    {
      // next is an object that is the route that we are starting to go to
      // current is an object that is the route where we are currently
      var currentPath = current.originalPath;
      var nextPath = next.originalPath;

      console.log('Starting to leave %s to go to %s', currentPath, nextPath);
    });

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error)
    {
      if (error.redirect)
      {
        $state.go(error.redirect);

      }
    });


    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
    {
      $rootScope.loadingProgress = true;
    });

    $rootScope.$on('$stateChangeSuccess', function (eevent, toState, toParams, fromState, fromParams) {
      //Set page title
      $rootScope.title = $state.current.title;
    });

    //
    // // De-activate loading indicator
    // var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
    // {
    //     $timeout(function ()
    //     {
    //         $rootScope.loadingProgress = false;
    //     });
    // });

    // Store state in the root scope for easy access
    $rootScope.state = $state;
    $rootScope.lang = 'en';

    // Cleanup
    $rootScope.$on('$destroy', function ()
    {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
    });
  }
})();

(function ()
{
  'use strict';

  angular
    .module('dbs')
    .config(routeConfig)
    .run(maintenanceMode)
  ;

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
  {
    //uncomment to enable pretty url without #/
    //
    // $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise('/home');

    /**
     * Layout Style Switcher
     *
     * This code is here for demonstration purposes.
     * If you don't need to switch between the layout
     * styles like in the demo, you can set one manually by
     * typing the template urls into the `State definitions`
     * area and remove this code
     */
      // Inject $cookies
    var $cookies;

    angular.injector(['ngCookies']).invoke([
      '$cookies', function (_$cookies)
      {
        $cookies = _$cookies;
      }
    ]);

    // State definitions
    $stateProvider
      .state('dbs', {
        abstract: true,
        views: {
          'main@': {
            templateUrl: 'app/core/layouts/layout-header-content-footer.html',
            controller: 'MainController as vm'
          },
          'header@dbs': {
            templateUrl: 'app/dbs/header/header.html',
            controller: 'HeaderController as vm'
          },
          'footer@dbs': {
            templateUrl: 'app/dbs/footer/footer.html',
            controller: 'FooterController as vm'
          },
        },
        title: "Home"
      })
      .state('dbs.maintenance', {
        url: '/maintenance',
        views: {
          'content@dbs': {
            templateUrl: 'app/dbs/maintenance.html'
          }
        },
        title: "Maintenance"
      })
      .state('dbs.notFound', {
        url: '/not-found',
        views: {
          'content@dbs': {
            templateUrl: 'app/dbs/not-found.html'
          }
        },
        title: "Page not found"
      })
      .state('dbs.conditionofuse', {
        url: '/website-condition-of-use',
        views: {
          'content@dbs': {
            templateUrl: 'app/dbs/condition-of-use.html'
          }
        },
        title: "Conditions of use"
      })
      .state('dbs.disclaimer', {
        url: '/disclaimer',
        views: {
          'content@dbs': {
            templateUrl: 'app/dbs/disclaimer.html'
          }
        },
        title: "Disclaimer"
      })
      .state('dbs.datapolicy', {
        url: '/data-policy',
        views: {
          'content@dbs': {
            templateUrl: 'app/dbs/data-policy.html'
          }
        },
        title: "Data Policy"
      });
  }

  /** @ngInject */
  function maintenanceMode($rootScope, $state)
  {
    $rootScope.$on('$stateChangeStart', goToMaintenance);
    $rootScope.$on('$stateChangeSuccess', goToMaintenance);

    function goToMaintenance(event, toState)
    {
      if (data.data.website && data.data.website.maintenance && toState.name !== "dbs.maintenance")
      {
        $state.go('dbs.maintenance');
        $state.transitionTo('dbs.maintenance');
      }
    };
  }
})();


(function ()
{
  'use strict';


  angular
    .module('dbs')
    .filter('momentFormat', function ()
    {
      function filter(dateString, outFormat, inFormat)
      {
        if (dateString)
        {
          return moment(dateString.replace(/\+.*/, ""), inFormat || "").format(outFormat || "");
        } else
        {
          return null;
        }
      }

      filter.$stateful = true;//force to recompute filter when locale changes
      return filter;
    })
    .filter('encode', function ()
    {
      function filter(urlToEncode)
      {
        return encodeURIComponent(urlToEncode)
      }

      filter.$stateful = true;//force to recompute filter when locale changes
      return filter;
    })
})();


(function ()
{
  'use strict';

  angular
    .module('dbs')

})();


(function ()
{
  'use strict';

  angular
    .module('dbs')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController($document)
  {
    var vm = this;

    var scrollTop = 0;

    $document.scroll(function(){
        scrollTop = $document.scrollTop();
        if (scrollTop >= 300) {
          $('.ui-nav').addClass('scrolled-nav');
        } else if (scrollTop < 300) {
          $('.ui-nav').removeClass('scrolled-nav');
        }     
    }); 
  }
})();


(function ()
{
  'use strict';

  angular
    .module('dbs');
})();


(function ()
{
  'use strict';

  angular
    .module('dbs')
    .config(config);

  /** @ngInject */
  function config($translateProvider, $provide)
  {
    // Put your common app configurations here

    // angular-translate configuration
    $translateProvider.preferredLanguage('en');
    $translateProvider.fallbackLanguage('en');
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
    for (var langCode in data.trans)
    {
      $translateProvider.translations(langCode, data.trans[langCode].website);
      $translateProvider.translations(langCode, {categorys: data.trans[langCode].categorys});
      $translateProvider.translations(langCode, {merchants: data.trans[langCode].merchants});
      $translateProvider.translations(langCode, {offers: data.trans[langCode].offers});
      $translateProvider.translations(langCode, {sliders: data.trans[langCode].sliders});
    }

    //select english language if browser isnt chinese
    var browserLang = navigator.languages
      ? navigator.languages[0]
      : (navigator.language || navigator.userLanguage);

    if (browserLang.indexOf("zh") === -1)
    {
      moment.locale('en-gb');
    }
    else
    {
      moment.locale('zh-cn');
    }

  }
})();


/**
 * Created by Benoit on 12/15/2016.
 */

/**
 * sprintf js implementation
 * "{0} is dead, but {1} is alive! {0} {2}".format("ASP", "ASP.NET")
 * outputs
 * ASP is dead, but ASP.NET is alive! ASP {2}
 */
// First, checks if it isn't implemented yet.
if (!String.prototype.format)
{
  String.prototype.format = function ()
  {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function (match, number)
    {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
        ;
    });
  };
}
String.prototype.contains = function (it)
{
  return this.indexOf(it) != -1;
};

if (!String.prototype.endsWith)
{
  String.prototype.endsWith = function (searchStr, Position)
  {
    // This works much better than >= because
    // it compensates for NaN:
    if (!(Position < this.length))
    {
      Position = this.length;
    } else
    {
      Position |= 0;
    } // round position
    return this.substr(Position - searchStr.length,
        searchStr.length) === searchStr;
  };
}

//console polyfill for ie
(function (global)
{
  'use strict';
  if (!global.console)
  {
    global.console = {};
  }
  var con = global.console;
  var prop, method;
  var dummy = function ()
  {
  };
  var properties = ['memory'];
  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
  'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
  'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
  while (prop = properties.pop())
  {
    if (!con[prop])
    {
      con[prop] = {};
    }
  }
  while (method = methods.pop())
  {
    if (!con[method])
    {
      con[method] = dummy;
    }
  }
  // Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? this : window);

//array.find ie polyfill
if (!Array.prototype.find)
{
  Object.defineProperty(Array.prototype, 'find', {
    value: function (predicate)
    {
      // 1. Let O be ? ToObject(this value).
      if (this == null)
      {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function')
      {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len)
      {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o))
        {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}
